(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[32105],{

/***/ 16991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CampaignItem; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(797864);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(179185);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(650983);
/* harmony import */ var _Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(528938);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CardContent = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  padding: 0.5rem;
`;
const Name = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  height: 54px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Flex = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledCard = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Z)(({ outDate }) => `
  box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.1);
  ${outDate && `
  filter: grayscale(100%);
  opacity: 0.6;
  `}
`);
const FromDateToDate = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div``;
const CampaignItem = (_a) => {
  var _b = _a, {
    imageUrl,
    name,
    targetPath,
    dateFrom,
    dateTo
  } = _b, props = __objRest(_b, [
    "imageUrl",
    "name",
    "targetPath",
    "dateFrom",
    "dateTo"
  ]);
  const formattedDateTo = dateTo ? dateTo.replace(/-/g, "/") : "2099/12/31T12:00:00Z";
  const outDate = new Date(formattedDateTo).getTime() - new Date().getTime() < 0;
  const dateFromStr = dateFrom ? new Date(dateFrom).toLocaleDateString() : "";
  const dateToStr = dateTo ? new Date(dateTo).toLocaleDateString() : "";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, __spreadProps(__spreadValues({}, props), {
    outDate
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CustomLink */ .x, {
    targetPath,
    targetType: "_blank"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .LazyImage */ .w, {
    aspectRatio: 1.93,
    src: imageUrl
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardContent, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CustomLink */ .x, {
    targetPath,
    targetType: "_blank"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Name, null, name)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Flex, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, !outDate && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FromDateToDate, null, dateFromStr, dateToStr ? ` - ${dateToStr}` : "")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
    disabled: outDate,
    tag: "a",
    href: targetPath,
    variant: "primary"
  }, outDate ? (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("\u0110\xE3 k\u1EBFt th\xFAc") : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Xem chi ti\u1EBFt")))));
};




/***/ }),

/***/ 775768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Logo = (_a) => {
  var _b = _a, {
    variant = "full",
    logoFull,
    logoLite,
    alt
  } = _b, props = __objRest(_b, [
    "variant",
    "logoFull",
    "logoLite",
    "alt"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadProps(__spreadValues({}, props), {
    src: variant === "full" ? logoFull : logoLite,
    alt
  }));
};




/***/ }),

/***/ 184164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/i18n.es.js
var i18n_es = __webpack_require__(334751);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Container/Container.es.js
var Container_es = __webpack_require__(358277);
// EXTERNAL MODULE: ../../.yarn/__virtual__/reflexbox-virtual-62ae8f912b/0/cache/reflexbox-npm-4.0.6-201af1058c-b532551c8b.zip/node_modules/reflexbox/dist/index.js
var dist = __webpack_require__(504545);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_es = __webpack_require__(650983);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Layout/Footer/components/FooterBlock/FooterBlock.es.js



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ColumnTitle = styled_es/* styled.div */.z.div`
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
`;
const StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)((props) => `
  font-size: 12px;
  color: #333;
  padding-left: 0px;
  text-align: left;
  text-decoration: none;
  padding-bottom: 0px;
  max-width: ${!props.block ? "72px" : "initial"};
  justify-content: flex-start;
`);
const ContactInnerLine = styled_es/* styled.div */.z.div`
  font-size: 12px;
  width: 100%;
  a {
    text-decoration: none;
  }
  span {
    line-height: 1.5rem;
  }
  padding-top: 0.365rem;
  padding-right: 0.75rem;
`;
const StyledImg = styled_es/* styled.img */.z.img((props) => `
  ${props.isLogo ? "max-width: 180px;" : ""}
  width: 100%;
`);
const FooterBlock = ({
  title,
  links = [],
  emails = [],
  phones = [],
  flexDir = "row",
  image,
  isLogoImage,
  btnBlock = true
}) => {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, title && /* @__PURE__ */ react.createElement(ColumnTitle, {
    key: title
  }, title), emails.map((email, index) => {
    return /* @__PURE__ */ react.createElement(ContactInnerLine, {
      key: `email-${index}`,
      dangerouslySetInnerHTML: {
        __html: `${email.children} <a href='mailto:${email.address}'>${email.address}</a>`
      }
    });
  }), phones.map((phone, index) => {
    return /* @__PURE__ */ react.createElement(ContactInnerLine, {
      key: `phone-${index}`,
      dangerouslySetInnerHTML: {
        __html: `${phone.children} <a href='tel:${phone.number.replace(/\./g, "")}'}>${phone.number}</a>`
      }
    });
  }), links.map((link, index) => {
    return /* @__PURE__ */ react.createElement(StyledButton, __spreadValues({
      tag: "a",
      block: btnBlock,
      link: true,
      key: `link-${index}`,
      flexDirection: flexDir
    }, link));
  }), image && /* @__PURE__ */ react.createElement(StyledImg, {
    isLogo: !!isLogoImage,
    src: image,
    alt: ""
  }));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Layout/Footer/Footer.es.js






const FooterWrapper = styled_es/* styled.div */.z.div(({ theme }) => `
  @media print {
    display: none;
  }
  border-top: solid 3px ${theme == null ? void 0 : theme.brand.primary};
  position: relative;
`);
const Wrapper = styled_es/* styled.nav */.z.nav(({ theme }) => `
  background-color: ${theme == null ? void 0 : theme.colors.white};
  padding: 1rem 0;
`);
const StyledContainer = (0,styled_es/* styled */.z)(Container_es/* Container */.W)`
  display: flex;
  margin-bottom: 10px;
`;
const ColumnInnerLine = styled_es/* styled.div */.z.div`
  font-size: 12px;
  width: 100%;
  padding-right: 8px;
  a {
    color: #333;
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  span {
    line-height: 1.5rem;
  }
`;
const StyledWrapper = (0,styled_es/* styled */.z)(Wrapper)(({ customBottomColor, theme }) => `
  background-color: ${customBottomColor && (theme == null ? void 0 : theme.colors[customBottomColor]) || "#e9edf2"};
  margin-top: -10px;
  padding-top: 30px;
  padding-bottom: 25px;
`);
const CompanyName = styled_es/* styled.div */.z.div`
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 15px;
`;
const BranchName = styled_es/* styled.span */.z.span`
  font-size: 12px;
  font-weight: bold;
`;
const Footer_es_StyledImg = styled_es/* styled.img */.z.img`
  width: 100%;
  max-width: 160px;
`;
const StyledLink = styled_es/* styled.a */.z.a`
  display: block;
  &:not(:first-child) {
    margin-top: 0.5rem;
  }
`;
const StyledDMCA = styled_es/* styled.div */.z.div`
  margin-top: 0.5rem;
  img {
    width: 100%;
    max-width: 100px;
  }
`;
const Description = styled_es/* styled.p */.z.p`
  font-size: 0.75rem;
  text-align: center;
  margin: 0;
`;
const getResponsiveWidth = (col) => {
  switch (col) {
    case 2:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 2];
    case 3:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 3];
    case 4:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 4];
    default:
      return [1 / 2, 1 / 3, 1 / 3, 1 / 5];
  }
};
const Footer = ({
  footer,
  customBottomColor
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  const currentUrlWithoutParams = typeof window !== "undefined" ? window.location.origin + window.location.pathname : "";
  return /* @__PURE__ */ react.createElement(FooterWrapper, null, (footer.bankList || footer.supportAndPolicy || footer.paymentMethods) && /* @__PURE__ */ react.createElement(Wrapper, null, footer.supportAndPolicy && /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap",
    justifyContent: "space-between",
    width: "100%"
  }, footer.supportAndPolicy.map((column, index) => {
    return /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
      width: !!footer.supportAndPolicy ? getResponsiveWidth(footer.supportAndPolicy.length) : void 0,
      key: index
    }, /* @__PURE__ */ react.createElement(FooterBlock, {
      title: column.title,
      links: column.links,
      emails: column.emails,
      phones: column.phones,
      image: column.image,
      isLogoImage: true
    }));
  }))), /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap"
  }, footer.paymentMethods && /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, 1, "40%"]
  }, /* @__PURE__ */ react.createElement(FooterBlock, {
    title: footer.paymentMethods.title,
    links: footer.paymentMethods.links,
    flexDir: "column",
    btnBlock: false
  })), footer.bankList && /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, 1, "60%"]
  }, /* @__PURE__ */ react.createElement(FooterBlock, {
    title: (0,i18n_es.t)("Danh s\xE1ch c\xE1c ng\xE2n h\xE0ng thanh to\xE1n online"),
    image: footer.bankList.imgSrc
  }))))), footer.bottom && /* @__PURE__ */ react.createElement(StyledWrapper, {
    customBottomColor
  }, /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap",
    width: "100%"
  }, /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "50%", "35%", "40%"]
  }, ((_a = footer.bottom) == null ? void 0 : _a.company) && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(CompanyName, null, (_b = footer.bottom) == null ? void 0 : _b.company.name), /* @__PURE__ */ react.createElement(ColumnInnerLine, {
    dangerouslySetInnerHTML: {
      __html: (_c = footer.bottom) == null ? void 0 : _c.company.detail
    }
  }))), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "50%", "35%", "40%"]
  }, footer.bottom.address && footer.bottom.address.map((addressDetail) => {
    return /* @__PURE__ */ react.createElement("div", {
      key: addressDetail.branchName
    }, /* @__PURE__ */ react.createElement(BranchName, null, addressDetail.branchName), ":", /* @__PURE__ */ react.createElement(ColumnInnerLine, null, addressDetail.branchAddress));
  }), footer.bottom.phone && footer.bottom.email && /* @__PURE__ */ react.createElement(ColumnInnerLine, null, `${(0,i18n_es.t)("S\u1ED1 \u0111i\u1EC7n tho\u1EA1i")}: ${footer.bottom.phone} - Email: ${footer.bottom.email} `)), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "100%", "30%", "20%"]
  }, !!((_e = (_d = footer == null ? void 0 : footer.bottom) == null ? void 0 : _d.registeredLogo) == null ? void 0 : _e.logo) && /* @__PURE__ */ react.createElement(StyledLink, {
    href: (_f = footer.bottom.registeredLogo) == null ? void 0 : _f.link,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ react.createElement(Footer_es_StyledImg, {
    src: footer.bottom.registeredLogo.logo,
    alt: "registered logo"
  })), !!((_h = (_g = footer == null ? void 0 : footer.bottom) == null ? void 0 : _g.verifiedLogo) == null ? void 0 : _h.logo) && /* @__PURE__ */ react.createElement(StyledLink, {
    href: (_i = footer.bottom.verifiedLogo) == null ? void 0 : _i.link,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ react.createElement(Footer_es_StyledImg, {
    src: footer.bottom.verifiedLogo.logo,
    alt: "verified logo"
  })), ((_j = footer == null ? void 0 : footer.bottom) == null ? void 0 : _j.dmcaBadgeLink) && ((_k = footer == null ? void 0 : footer.bottom) == null ? void 0 : _k.dmcaId) && /* @__PURE__ */ react.createElement(StyledDMCA, null, /* @__PURE__ */ react.createElement("a", {
    href: `//www.dmca.com/Protection/Status.aspx?ID=${(_l = footer == null ? void 0 : footer.bottom) == null ? void 0 : _l.dmcaId}&refurl=${currentUrlWithoutParams}`,
    title: "DMCA.com Protection Status",
    className: "dmca-badge",
    target: "_blank",
    rel: "noreferrer"
  }, /* @__PURE__ */ react.createElement("img", {
    src: `${(_m = footer == null ? void 0 : footer.bottom) == null ? void 0 : _m.dmcaBadgeLink}?ID=${(_n = footer == null ? void 0 : footer.bottom) == null ? void 0 : _n.dmcaId}`,
    alt: "DMCA Protected"
  })))), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1]
  }, ((_o = footer == null ? void 0 : footer.bottom) == null ? void 0 : _o.description) && /* @__PURE__ */ react.createElement(Description, {
    dangerouslySetInnerHTML: {
      __html: footer.bottom.description
    }
  }))))));
};




/***/ }),

/***/ 872861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ PriceInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(526439);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: relative;
  overflow: hidden;
`;
const StyledInput = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.input */ .z.input`
  width: 100%;
  height: 2.1rem;
  line-height: 2.1rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  z-index: 1;
  &:focus {
    outline: 0;
  }
`;
const PriceInput = (_a) => {
  var _b = _a, {
    value,
    placeholder,
    onChange,
    onEnter
  } = _b, props = __objRest(_b, [
    "value",
    "placeholder",
    "onChange",
    "onEnter"
  ]);
  const getValue = (value2) => {
    const v = parseInt(value2.replace(/[^0-9]/g, ""));
    const numberWithSeparator = isNaN(v) ? "" : (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .thoundsandDelimiter */ .t)(v);
    return {
      displayValue: numberWithSeparator,
      value: isNaN(v) ? 0 : v
    };
  };
  const [val, setVal] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getValue(value.toString()).displayValue);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setVal(getValue(value.toString()).displayValue);
  }, [value]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, {
    type: "text",
    maxLength: 14,
    placeholder,
    value: val,
    onChange: (e) => {
      const { value: value2 } = getValue(e.target.value);
      if (onChange)
        onChange(value2);
    },
    onKeyDown: (e) => {
      if (onEnter && e.keyCode === 13) {
        const { value: value2 } = getValue(val);
        onEnter(value2);
      }
    }
  }));
};




/***/ }),

/***/ 569907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ EditableDetailTable; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_slug__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93512);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(179185);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(432989);
/* harmony import */ var _Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(528938);
/* harmony import */ var _mobile_ProductPrice_ProductPrice_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(558425);
/* harmony import */ var _TableDivider_TableDivider_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(200666);








const OrderItemsWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.table */ .z.table`
  margin: 16px 8px 0 8px;
  border-radius: 8px;
  border: 1px solid #e4e5f0;
  background-color: white;
  overflow: hidden;
  font-size: 14px;
  color: #333;
  border-spacing: 0;
  border-collapse: initial;
  table-layout: fixed;
  width: 98%;

  p {
    margin: 0;
    padding: 0;
  }

  thead {
    background: #e4e5f0;
  }

  td {
    vertical-align: top;
  }

  th {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    padding: 16px;

    &:nth-of-type(1) {
      width: 60%;
    }
    &:nth-of-type(2) {
      width: 20%;
    }
    &:nth-of-type(3) {
      width: 20%;
    }
  }
`;
const OrderProduct = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.tr */ .z.tr`
  td {
    padding: 16px;
  }
`;
const ProductItem = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.td */ .z.td`
  display: flex;
`;
const ProductItemRight = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  margin-left: 16px;

  & > :not(:last-child) {
    margin-bottom: 4px;
  }
`;
const ItemImg = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w)`
  width: 56px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  margin: 0;
  padding: 0;
  max-width: 56px;
`;
const ItemName = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.p */ .z.p`
  word-wrap: break-word;
  line-height: 20px;
`;
const ItemQuantity = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.td */ .z.td`
  text-align: center;
`;
const ItemReturnQuantity = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.td */ .z.td`
  text-align: center;
`;
const TableHead = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.th */ .z.th(({ direction }) => `
    text-align: ${direction};
    font-weight: 700 !important;
  `);
const QuantitySelect = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  text-align: center;
  width: 120px;
  float: right;
`;
const Stepper = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .NumberStepperAllowBlank */ .H)`
  border: 1px solid #e4e5f0;
  border-radius: 4px;
  button {
    outline: none;
  }
`;
const OrderPrize = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.tr */ .z.tr`
  td {
    padding: 0 16px 8px 16px;
  }
`;
const PrizeItem = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.td */ .z.td(({ last }) => `
    padding-left: 40px !important;
    padding-bottom: ${last ? "16px !important" : ""};
  `);
const PrizeImg = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(ItemImg)`
  margin-right: 16px;
  width: 32px;
  height: 32px;
  max-width: 32px;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
`;
const PrizeName = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(ItemName)`
  font-size: 12px;
  line-height: 16px;
  color: #333;
`;
const GiftsWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  background: #f8f8fc;
  padding: 8px;
  margin-top: -10px;
  border-radius: 8px;
`;
const EditableDetailTable = ({
  products,
  onChangeQuantity,
  showQuantityError = false
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OrderItemsWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("thead", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("tr", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TableHead, {
    direction: "left"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("S\u1EA3n ph\u1EA9m")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TableHead, {
    direction: "center"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("S\u1ED1 l\u01B0\u1EE3ng")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TableHead, {
    direction: "center"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Tr\u1EA3 l\u1EA1i")))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("tbody", null, products.map((product, index) => {
    var _a;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      key: product.sku
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OrderProduct, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductItem, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ItemImg, {
      src: product.imageUrl || "",
      alt: "item"
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductItemRight, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x, {
      targetPath: `/${(0,_teko_slug__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(product.name)}-s${product.sku}.html`,
      targetType: "_blank",
      passHref: true
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ItemName, null, product.displayName || product.name)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mobile_ProductPrice_ProductPrice_es_js__WEBPACK_IMPORTED_MODULE_7__/* .ProductPrice */ .j, {
      marginTop: "4px",
      price: product.price,
      listedPrice: product.unitPrice,
      variant: "normal"
    }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ItemQuantity, null, product.quantity.toLocaleString("vi-VN")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ItemReturnQuantity, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QuantitySelect, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Stepper, {
      setValue: (newValue) => {
        onChangeQuantity == null ? void 0 : onChangeQuantity(newValue, product.sku);
      },
      value: 0,
      maximumValue: product.quantity,
      variant: "normal",
      showError: showQuantityError
    })))), (_a = product.prizes) == null ? void 0 : _a.map(({ name, imageUrl }, index2) => {
      var _a2;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OrderPrize, {
        key: index2
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PrizeItem, {
        last: (((_a2 = product.prizes) == null ? void 0 : _a2.length) || 0) - 1 === index2,
        colSpan: 3
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GiftsWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PrizeImg, {
        src: imageUrl || "",
        alt: "item"
      }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PrizeName, null, name))));
    }), index !== products.length - 1 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TableDivider_TableDivider_es_js__WEBPACK_IMPORTED_MODULE_8__/* .TableDivider */ .E, {
      colCount: 3
    }));
  })));
};




/***/ }),

/***/ 200666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ TableDivider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75537);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);




const Td = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.td */ .z.td`
  padding: 0 !important;
`;
const Content = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ ml, mr }) => _emotion_react__WEBPACK_IMPORTED_MODULE_2__.css`
    height: 1px;
    background-color: #e0e0e0;
    margin-left: ${ml}px;
    margin-right: ${mr}px;
  `);
const TableDivider = ({
  colCount,
  mr = 0,
  ml = 0
}) => {
  const content = [];
  for (let i = 0; i < colCount; i++) {
    content.push(/* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Td, {
      key: i
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, {
      ml: i === 0 ? ml : 0,
      mr: i === colCount - 1 ? mr : 0
    })));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("tr", null, content);
};




/***/ }),

/***/ 406834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ DefaultPromotions; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46610);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(526439);
/* harmony import */ var reflexbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(504545);
/* harmony import */ var _DetailGifts_DetailGifts_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(903677);
/* harmony import */ var _DiscountPromotion_DiscountPromotion_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(323442);







const StyledIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l)(({ theme }) => `
  margin-left: 5px;
  --button-icon-color: ${theme == null ? void 0 : theme.brand.primary};
  `);
const StyledCurrency = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .Currency */ .F)`
  margin: 0 4px;
  color: #ed2101;
  font-weight: 500;
`;
const StyledVoucherName = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.span */ .z.span`
  color: #ed2101;
  font-weight: 500;
`;
const DefaultPromotions = ({
  defaultGifts,
  defaultPromotions,
  discount,
  defaultVouchers = []
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, discount > 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(reflexbox__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
    marginTop: 2
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(reflexbox__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
    width: "8%"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: "promotion",
    size: 20
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(reflexbox__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
    width: "92%"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("Gi\u1EA3m tr\u1EF1c ti\u1EBFp"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, {
    value: discount
  }))), !!defaultGifts.length && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DetailGifts_DetailGifts_es_js__WEBPACK_IMPORTED_MODULE_6__/* .DetailGifts */ .x, {
    gifts: defaultGifts
  }), defaultPromotions.map((promo, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DiscountPromotion_DiscountPromotion_es_js__WEBPACK_IMPORTED_MODULE_7__/* .DiscountPromotion */ .k, {
    key: index,
    promotion: promo
  })), defaultVouchers.map((voucher, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(reflexbox__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
    key: index,
    marginTop: 2
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(reflexbox__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
    width: "8%"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: "promotion",
    size: 20
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(reflexbox__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
    width: "92%"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("T\u1EB7ng"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DetailGifts_DetailGifts_es_js__WEBPACK_IMPORTED_MODULE_6__/* .Quantity */ .h, null, "x", voucher.quantity), " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledVoucherName, null, voucher.name)))));
};




/***/ }),

/***/ 903677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Quantity; },
/* harmony export */   "x": function() { return /* binding */ DetailGifts; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(179185);



const StyledGift = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  align-items: center;
  padding: 0.25rem 0;
`;
const GiftName = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  margin-left: 0.25rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.75rem;
`;
const EndAt = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span(({ theme }) => `
    color: ${theme == null ? void 0 : theme.colors.gray400};
    margin-left: 0.5rem;
    font-size: 0.75rem;
  `);
const Quantity = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  font-size: 0.75rem;
  color: #848788;
  margin-left: 0.5rem;
`;
const DetailGifts = ({
  gifts
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, gifts.map((gift, index) => {
  var _a;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledGift, {
    key: index
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w, {
    height: 32,
    width: 32,
    border: true,
    borderRadius: 2,
    contain: true,
    src: ((_a = gift.image) == null ? void 0 : _a.src) || ""
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Quantity, null, "x", gift.quantity), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GiftName, null, gift.name), gift.endAt && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(EndAt, null, gift.endAt));
}));




/***/ }),

/***/ 323442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ DiscountPromotion; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var reflexbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(504545);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46610);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23212);
/* harmony import */ var _Promotion_PromotionInfo_PromotionInfo_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(468382);







const Coupon = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  text-transform: uppercase;
  padding: 0 6px;
  margin: 0 4px;
  background-color: #ef2741;
  color: #fff;
  border-radius: 2px;
  display: inline-block;
`;
const StyledIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l)(({ theme }) => `
  margin-left: 5px;
  --button-icon-color: ${theme == null ? void 0 : theme.brand.primary};
  `);
const DiscountPromotion = ({
  promotion
}) => {
  var _a, _b;
  if (!promotion || !((_a = promotion.benefit.money) == null ? void 0 : _a.length))
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(reflexbox__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
    marginTop: 2
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(reflexbox__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
    width: "8%"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: "promotion",
    size: 20
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(reflexbox__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
    width: "92%"
  }, promotion.type === _types_es_js__WEBPACK_IMPORTED_MODULE_4__/* .PromotionType.COUPON */ .q.COUPON && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("\u0110\xE3 \xE1p d\u1EE5ng m\xE3 gi\u1EA3m gi\xE1"), " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Coupon, null, " ", ((_b = promotion.condition) == null ? void 0 : _b.coupon) || "", " "), " ", (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("gi\u1EA3m"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Promotion_PromotionInfo_PromotionInfo_es_js__WEBPACK_IMPORTED_MODULE_6__/* .PromotionInfo */ .z, {
    money: promotion.benefit.money[0],
    condition: promotion.condition || null
  })), promotion.type === _types_es_js__WEBPACK_IMPORTED_MODULE_4__/* .PromotionType.PRODUCT */ .q.PRODUCT && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("Gi\u1EA3m tr\u1EF1c ti\u1EBFp"), " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Promotion_PromotionInfo_PromotionInfo_es_js__WEBPACK_IMPORTED_MODULE_6__/* .PromotionInfo */ .z, {
    money: promotion.benefit.money[0],
    condition: promotion.condition || null
  }))));
};




/***/ }),

/***/ 560585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ActivatedFilters": function() { return /* reexport */ ActivatedFilters_es/* ActivatedFilters */.x; },
  "AdvancedFilterRow": function() { return /* reexport */ AdvancedFilterRow; },
  "AppliedCoupon": function() { return /* reexport */ AppliedCoupon; },
  "Article": function() { return /* reexport */ Article_es/* Article */.d; },
  "Breadcrumb": function() { return /* reexport */ Breadcrumb; },
  "BuildPcItem": function() { return /* reexport */ BuildPcItem_es/* BuildPcItem */.y; },
  "BuildPcModal": function() { return /* reexport */ BuildPcModal; },
  "BuildPcModalContent": function() { return /* reexport */ BuildPcModalContent_es/* BuildPcModalContent */.b; },
  "BuildPcModalHeader": function() { return /* reexport */ BuildPcModalHeader_es/* BuildPcModalHeader */.t; },
  "BuildPcNumberStepper": function() { return /* reexport */ BuildPcNumberStepper_es/* BuildPcNumberStepper */.F; },
  "BuildPcSummary": function() { return /* reexport */ BuildPcSummary_es/* BuildPcSummary */.b; },
  "BuildPcTabs": function() { return /* reexport */ BuildPcTabs_es/* BuildPcTabs */.N; },
  "CampaignItem": function() { return /* reexport */ CampaignItem_es/* CampaignItem */.x; },
  "CartLinePrint": function() { return /* reexport */ CartLinePrint; },
  "CartNumberTracking": function() { return /* reexport */ CartNumberTracking_es/* CartNumberTracking */.w; },
  "CustomLink": function() { return /* reexport */ CustomLink_es/* CustomLink */.x; },
  "DefaultPromotions": function() { return /* reexport */ DefaultPromotions_es/* DefaultPromotions */.G; },
  "DetailGifts": function() { return /* reexport */ DetailGifts_es/* DetailGifts */.x; },
  "DetailInfo": function() { return /* reexport */ DetailInfo; },
  "DetailNavBar": function() { return /* reexport */ DetailNavBar_es/* DetailNavBar */.W; },
  "DetailTable": function() { return /* reexport */ DetailTable; },
  "DiscountPromotion": function() { return /* reexport */ DiscountPromotion_es/* DiscountPromotion */.k; },
  "DisplayStatus": function() { return /* reexport */ DisplayStatus; },
  "DropDownItem": function() { return /* reexport */ NavBarDropDown_es/* DropDownItem */.b; },
  "EditableDetailTable": function() { return /* reexport */ EditableDetailTable_es/* EditableDetailTable */.M; },
  "FeaturedBanners": function() { return /* reexport */ FeaturedBanners; },
  "Filter": function() { return /* reexport */ Filter; },
  "FilterRow": function() { return /* reexport */ FilterRow; },
  "FlashSaleBadge": function() { return /* reexport */ FlashSaleBadge_es/* FlashSaleBadge */.j; },
  "Footer": function() { return /* reexport */ Footer_es/* Footer */.$; },
  "FormattedTime": function() { return /* reexport */ FormattedTime; },
  "HorizontalSelect": function() { return /* reexport */ HorizontalSelect_es/* HorizontalSelect */.n; },
  "ImageGallery": function() { return /* reexport */ ImageGallery_es/* ImageGallery */.h; },
  "InvoiceSectionKey": function() { return /* reexport */ OrderDetailInvoices_es/* InvoiceSectionKey */.i; },
  "Invoices": function() { return /* reexport */ Invoices_es/* Invoices */.x; },
  "JDDropdown": function() { return /* reexport */ JDDropdown_es/* JDDropdown */.F; },
  "ListItem": function() { return /* reexport */ ListItem_es/* ListItem */.H; },
  "ListTile": function() { return /* reexport */ ListTile_es/* ListTile */.x; },
  "Loading": function() { return /* reexport */ Loading_es/* Loading */.g; },
  "Logo": function() { return /* reexport */ Logo_es/* Logo */.T; },
  "LogoLoading": function() { return /* reexport */ LogoLoading_es/* LogoLoading */.h; },
  "MiniDropdown": function() { return /* reexport */ MiniDropdown_es/* MiniDropdown */._; },
  "MiniSlides": function() { return /* reexport */ MiniSlides_es/* MiniSlides */.H; },
  "NAMESPACE": function() { return /* reexport */ i18n_es/* NAMESPACE */.A; },
  "NavBarDropDown": function() { return /* reexport */ NavBarDropDown_es/* NavBarDropDown */._; },
  "NavBarWithSearchBox": function() { return /* reexport */ NavBarWithSearchBox_es/* NavBarWithSearchBox */.f; },
  "NavBarWithTitle": function() { return /* reexport */ NavBarWithTitle_es/* NavBarWithTitle */.X; },
  "NoProductsFound": function() { return /* reexport */ NoProductsFound_es/* NoProductsFound */.H; },
  "ORDER_TAB_CANCELED": function() { return /* reexport */ order_es/* ORDER_TAB_CANCELED */.VI; },
  "ORDER_TAB_DELIVERED": function() { return /* reexport */ order_es/* ORDER_TAB_DELIVERED */.SQ; },
  "ORDER_TAB_WAIT_CONFIRM": function() { return /* reexport */ order_es/* ORDER_TAB_WAIT_CONFIRM */.A5; },
  "ORDER_TAB_WAIT_DELIVER": function() { return /* reexport */ order_es/* ORDER_TAB_WAIT_DELIVER */.aA; },
  "ORDER_TAB_WAIT_PAYMENT": function() { return /* reexport */ order_es/* ORDER_TAB_WAIT_PAYMENT */.T0; },
  "OrderBy": function() { return /* reexport */ types_es/* OrderBy */.d; },
  "OrderDetailInvoices": function() { return /* reexport */ OrderDetailInvoices_es/* OrderDetailInvoices */.m; },
  "OrderList": function() { return /* reexport */ OrderList; },
  "OrderProductLine": function() { return /* reexport */ OrderProductLine_es/* OrderProductLine */.J; },
  "OrderProductList": function() { return /* reexport */ OrderProductList_es/* OrderProductList */.G; },
  "OrderPromotion": function() { return /* reexport */ OrderPromotion; },
  "OrderShipment": function() { return /* reexport */ OrderShipment; },
  "PreLoad": function() { return /* reexport */ PreLoad_es/* PreLoad */.b; },
  "PriceInput": function() { return /* reexport */ PriceInput_es/* PriceInput */.t; },
  "PricePackage": function() { return /* reexport */ PricePackage; },
  "PrintBuildPc": function() { return /* reexport */ PrintBuildPc_es/* PrintBuildPc */.r; },
  "PrintBuildPcItem": function() { return /* reexport */ PrintBuildPcItem_es/* PrintBuildPcItem */.p; },
  "ProductCard": function() { return /* reexport */ ProductCard; },
  "ProductCheckoutInfo": function() { return /* reexport */ ProductCheckoutInfo_es/* ProductCheckoutInfo */.X; },
  "ProductCombos": function() { return /* reexport */ ProductCombos; },
  "ProductCoupon": function() { return /* reexport */ ProductCoupon; },
  "ProductDiscount": function() { return /* reexport */ ProductDiscount; },
  "ProductGifts": function() { return /* reexport */ ProductGifts_es/* ProductGifts */.W; },
  "ProductHeaderMobile": function() { return /* reexport */ ProductHeaderMobile_es/* ProductHeaderMobile */.E; },
  "ProductImages": function() { return /* reexport */ ProductImages; },
  "ProductImagesMobile": function() { return /* reexport */ ProductImagesMobile_es/* ProductImagesMobile */.K; },
  "ProductName": function() { return /* reexport */ ProductName_es/* ProductName */.r; },
  "ProductPrice": function() { return /* reexport */ ProductPrice_es/* ProductPrice */.j; },
  "ProductReview": function() { return /* reexport */ ProductReview; },
  "ProductShortDescription": function() { return /* reexport */ ProductShortDescription; },
  "ProductShortDescriptionMobile": function() { return /* reexport */ ProductShortDescriptionMobile_es/* ProductShortDescriptionMobile */.X; },
  "ProductSpecificationsMobile": function() { return /* reexport */ ProductSpecificationsMobile_es/* ProductSpecificationsMobile */.t; },
  "ProductVariant": function() { return /* reexport */ ProductVariant; },
  "ProductVariants": function() { return /* reexport */ ProductVariants; },
  "ProductVariantsMobile": function() { return /* reexport */ ProductVariantsMobile_es/* ProductVariantsMobile */.$; },
  "ProductsGrid": function() { return /* reexport */ ProductsGrid; },
  "PromoBlock": function() { return /* reexport */ PromoBlock; },
  "PromoBlockStatus": function() { return /* reexport */ PromoBlockStatus; },
  "PromoItem": function() { return /* reexport */ PromoItem_es/* PromoItem */.D; },
  "PromoItemType": function() { return /* reexport */ PromoItem_es/* PromoItemType */.r; },
  "PromoTable": function() { return /* reexport */ PromoTable; },
  "Promotion": function() { return /* reexport */ Promotion_es/* Promotion */.L; },
  "PromotionDetail": function() { return /* reexport */ PromotionDetail; },
  "PromotionInfo": function() { return /* reexport */ PromotionInfo_es/* PromotionInfo */.z; },
  "PromotionType": function() { return /* reexport */ types_es/* PromotionType */.q; },
  "Quantity": function() { return /* reexport */ DetailGifts_es/* Quantity */.h; },
  "SearchSuggestions": function() { return /* reexport */ SearchSuggestions; },
  "SelectOption": function() { return /* reexport */ SelectOption_es/* SelectOption */.$; },
  "SelectionGroup": function() { return /* reexport */ SelectionGroup; },
  "SellerCard": function() { return /* reexport */ SellerCard; },
  "ShowMoreBtn": function() { return /* reexport */ ShowMoreBtn; },
  "SideNav": function() { return /* reexport */ SideNav; },
  "SortBar": function() { return /* reexport */ SortBar; },
  "Specifications": function() { return /* reexport */ Specifications_es/* Specifications */.G; },
  "Stepper": function() { return /* reexport */ Stepper; },
  "TableDivider": function() { return /* reexport */ TableDivider_es/* TableDivider */.E; },
  "TermAndPolicyText": function() { return /* reexport */ TermAndPolicyText; },
  "Text": function() { return /* reexport */ Text_es/* Text */.x; },
  "UserCard": function() { return /* reexport */ UserCard; },
  "VariantItem": function() { return /* reexport */ VariantItem_es/* VariantItem */.D; },
  "lang": function() { return /* reexport */ lang$1; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/types.es.js
var types_es = __webpack_require__(23212);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/i18n.es.js
var i18n_es = __webpack_require__(334751);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/constant/order.es.js
var order_es = __webpack_require__(914562);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.Cart.CartDiscount.CartDiscountSeller.0": "Một số mã giảm giá có điều kiện đặc biệt, bạn cần",
	"src.Cart.CartDiscount.CartDiscountSeller.1": "Mã giảm giá/Phiếu mua hàng sẽ không thể khôi phục sau khi đặt hàng",
	"src.Common.PhoneLogin.PhoneLogin.0": "Sử dụng số điện thoại để Đăng nhập hoặc Đăng ký tài khoản của bạn",
	"src.mobile.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!",
	"src.mobile.ProductDetail.ProductShortDescriptionMobile.0": "Mô tả sản phẩm sẽ được cập nhật trong thời gian sớm nhất !"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/lang/en.es.js
var enLang = {
	"Tên sản phẩm đang được cập nhật": "Product name is updating",
	"Tặng ngay": "Receive",
	"Vui lòng chọn linh kiện": "Please select accessory",
	"Liên hệ": "Contact",
	"Chọn": "Select",
	"Bộ lọc": "Filter",
	"Sắp xếp theo": "Sort by",
	"Bán chạy": "Best selling",
	"Giá tăng dần": "Price ascend",
	"Giá giảm dần": "Price descend",
	"Tìm linh kiện": "Search accessory",
	"Thương hiệu": "Brand",
	"Khác": "Other",
	"Bàn phím số": "Numeric keyboard",
	"không phím số": "no number pad",
	"có phím số": "number pad",
	"Bộ nhớ laptop (filter)": "Laptop memory (filter)",
	"Chip đồ họa rời": "Discrete graphics chip",
	"Chuẩn độ phân giải": "Standard resolution",
	"Đầu đọc thẻ nhớ SD": "SD card reader",
	"Chi phí dự tính:": "Estimated amount:",
	"Thêm vào giỏ hàng": "Add to cart",
	"Cấu hình": "Configuration",
	"Tải cấu hình": "Download configuration",
	"Tạo lại": "Reset configuration",
	"Tổng chi phí:": "Total amount:",
	"Đã kết thúc": "Finished",
	"Xem chi tiết": "View detail",
	"với tất cả các nhà cung cấp": "with all suppliers",
	"với {{ApplySellerIdsLength}} nhà cung cấp": "with {{ApplySellerIdsLength}} suppliers",
	"Mã giảm giá/Phiếu mua hàng": "Discount code/e-voucher",
	"Nhập mã của bạn": "Input code",
	"Áp dụng ngay": "Apply now",
	"src.Cart.CartDiscount.CartDiscountSeller.0": "Some discount codes have special conditions, you need",
	"đăng nhập": "login",
	"để xem tất cả mã khuyến mại của bạn": "to view all applicable promotions",
	"src.Cart.CartDiscount.CartDiscountSeller.1": "Discount code/e-voucher is irrevertible after check-out",
	"Giảm giá toàn đơn": "Full discount",
	"Tặng 1 Ba lô Acer": "Receive 1 Acer backpack",
	"Tặng 1 bàn phím Logitech Tặng 1 bàn phím Logitech": "Receive Logitech keyboard",
	"Giỏ hàng chưa có sản phẩm nào": "Cart is empty",
	"Mua sắm ngay": "Shopping now",
	"Trường bắt buộc": "Required fields",
	"Email không đúng định dạng": "Email is invalid format",
	"Tên doanh nghiệp": "Company",
	"Nhập tên doanh nghiệp": "Input company name",
	"Mã số thuế": "Tax code",
	"Nhập mã số thuế": "Input tax code",
	"Email nhận hóa đơn": "Email",
	"Nhập email nhận hóa đơn": "Input email",
	"Địa chỉ trên hóa đơn": "Address",
	"Nhập địa chỉ trên hóa đơn": "Input address",
	"Thông tin người đặt hàng": "Customer information",
	"Họ tên": "Name",
	"Nhập họ tên": "Input name",
	"Số điện thoại": "Phone number",
	"Nhập số điện thoại": "Input phone number",
	"Nhập email": "Input email",
	"Địa chỉ nhận hàng": "Address",
	"Tỉnh/Thành phố": "Province",
	"Quận huyện": "District",
	"Phường xã": "Ward",
	"Địa chỉ": "Address",
	"Nhập địa chỉ": "Input address",
	"Sử dụng làm thông tin người mua hàng": "Use as delivery information",
	"Thông tin người mua hàng": "Delivery information",
	"Lưu địa chỉ": "Save",
	"Sắp cháy hàng": "Out of stock soon",
	"Còn lại {{remain}}": "Remain {{remain}}",
	"Còn lại ": "Remain ",
	"(Đã bao gồm VAT{{var0}})": "(VAT included {{var0}})",
	"(Đã bao gồm phí giao hàng)": "(shipping fee included)",
	"Tổng tạm tính": "Grand total",
	"Tổng nâng giá": "Total price",
	"Phí vận chuyển": "Shipping fee",
	"Giảm giá": "Discount",
	"Thành tiền": "Total amount",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Đã gửi mã OTP": "OTP sent",
	"Đã gửi lại mã OTP": "OTP re-sent",
	"Tiếp tục với số điện thoại": "Continue with phone number",
	"src.Common.PhoneLogin.PhoneLogin.0": "Login or Registration with your phone number",
	"Gửi": "Send",
	"Vui lòng nhập số OTP đã được gửi về số điện thoại {{phone}} để thực hiện đăng nhập": "Please input OTP sent to your phone number {{phone}} to login",
	"Gửi lại mã": "Re-send",
	"Gửi lại mã sau {{countDownTime}}s": "Re-send after {{countDownTime}}s",
	"QUÀ TẶNG": "GIFT",
	"LIÊN HỆ": "CONTACT",
	"Hết hàng": "Out of stock",
	"Thêm vào giỏ": "Add to cart",
	"Chỉ giao hàng tại HN & HCM": "Delivery within HN & HCM only",
	"Trả góp 0%": "Installment 0%",
	"Hàng đặt trước": "Pre-order",
	"Nhập mã": "Input code",
	"Giảm ngay": "Discount",
	"Chỉ còn": "Only",
	"sản phẩm": "product",
	"Nhận xét và đánh giá": "Feedback and review",
	"Trung bình của:": "Average of:",
	"nhận xét": "review",
	"Chưa có đánh giá nào": "No rating",
	"Nhận xét của bạn": "Your review",
	"1. Đánh giá về sản phẩm:": "1. Product rating:",
	"2. Viết nhận xét:": "2. Review:",
	"Nhận xét về sản phẩm": "Review about product",
	"Gửi nhận xét": "Submit review",
	"Bỏ chọn": "Un-select",
	"Áp dụng": "Apply",
	"Mua thêm": "Buy more",
	"Từ khóa phổ biến": "Popular keyword",
	"Lịch sử tìm kiếm": "Search history",
	"Nhập lý do": "Reason",
	"cho đơn hàng": "for the order",
	"cho đơn hàng tối thiểu": "for the order min",
	"cho đơn hàng tối đa": "for the order max",
	"cho đơn hàng từ": "for the order from",
	"đến": "to",
	"Giảm thêm": "Discount",
	"% tối đa": "% max",
	"có chứa sản phẩm hiện tại": "include the current product",
	"điều kiện sử dụng và chính sách": "terms of use and policy",
	"Tài khoản của": "Account of",
	"Danh sách các ngân hàng thanh toán online": "List of online payment banks",
	"Hỗ trợ khách hàng": "Customer support",
	"Thẻ ưu đãi": "Preferential card",
	"Phiếu mua hàng": "e-voucher",
	"Trung tâm bảo hành": "Service Center",
	"Thanh toán và giao hàng": "Payment and delivery",
	"Dịch vụ sửa chữa và bảo trì": "Repair and maintenance service",
	"Chính sách Mua hàng và Bảo hành": "Purchase and Warranty Policy",
	"Quy định chung": "General rules",
	"Chính sách Bảo mật Thông tin": "Information Privacy Policy",
	"Chính sách Vận chuyển, Giao nhận": "Shipping and Delivery Policy",
	"Chính sách bảo hành": "Warranty Policy",
	"Chính sách mặt hàng Điện máy": "Policy on electrical goods",
	"Chính sách đổi trả và hoàn tiền": "Return and Refund Policy",
	"Quy định giá cả và hình thức thanh toán": "Regulation of prices and forms of payment",
	"Chính sách trả góp": "Installment Policy",
	"Thông tin Phong Vũ": "Phong Vũ information",
	"Thông tin liên hệ": "Contact Info",
	"Hệ thống Showroom": "Showrooms",
	"Giới thiệu Phong Vũ": "Phong Vũ introduction",
	"Hỏi đáp": "Q&A",
	"Tin công nghệ": "Tech news",
	"Tuyển dụng": "Career",
	"Cộng đồng Phong Vũ": "Phong Vũ community",
	"Phong Vũ Hội": "Phong Vũ Community",
	"Gọi Mua hàng: 1800 6867 (miễn phí)": "Call to buy: 1800 6867 (free)",
	"Gọi Chăm sóc: 1800 6865 (miễn phí)": "Call for support: 1800 6865 (free)",
	"Tổng đài (cũ): 1900 1835 (1000đ/phút)": "Hotline (old): 1900 1835 (1000đ/minute)",
	"Email liên hệ": "Email support",
	"Hỗ trợ Khách hàng:": "Customer support:",
	"Liên hệ báo giá:": "Contact for quotation:",
	"Hợp tác phát triển:": "Collaboration:",
	"Phương thức thanh toán": "Payment method",
	"Tiền mặt": "Cash",
	"Trả góp": "Installment",
	"Công ty cổ phần thương mại dịch vụ Phong Vũ": "Phong Vũ trading joint stock company",
	"Xóa bộ lọc": "Reset filter",
	"Bộ lọc nâng cao": "Advance filter",
	"Khuyến mãi tốt nhất": "Best promotion",
	"Mới về": "Latest",
	"Giá thấp nhất": "Lowest price",
	"Giá cao nhất": "Highest price",
	"Tìm": "Search",
	"Sản phẩm": "Product",
	"Giá trị": "Value",
	"Số lượng": "Quantity",
	"Tổng tiền": "Total amount",
	"Trả lại": "Return",
	"Cung cấp bởi": "Provided by",
	"{{quantity}}x Giảm giá {{var0}}": "{{quantity}}x Discount {{var0}}",
	"{{VoucherQuantity}}x Voucher giảm giá cho đơn hàng sau": "{{VoucherQuantity}}x Voucher for the next order",
	"KHUYẾN MÃI CHO ĐƠN HÀNG": "ORDER PROMOTIONS",
	"Vận đơn {{index}}{{var0}}": "Shipment {{index}}{{var0}}",
	"Xem chi tiết vận đơn": "View shipment detail",
	"Cần thanh toán:": "Remain payment:",
	"Khuyến mãi cho đơn hàng": "Order promotion",
	"Tạm tính": "Grand total",
	"Tặng phiếu mua hàng điện máy Phong Vũ": "Receive e-voucher for eletrics at Phong Vũ",
	"Đặt hàng thành công": "Place order successfully",
	"Đóng gói xong": "Packed",
	"Đang lấy hàng": "Picking",
	"Đang vận chuyển": "Delivering",
	"Giao hàng thành công": "Delivered",
	"Mã đơn hàng": "Order code",
	"Ngày mua": "Created date",
	"Tổng tiền (đ)": "Total amount (đ)",
	"Trạng thái": "Status",
	"Card màn hình GIGABYTE GeForce GTX 1660Ti 6GB GDDR6 OC(GV-N166TOC-6GD)": "Graphic card GIGABYTE GeForce GTX 1660Ti 6GB GDDR6 OC(GV-N166TOC-6GD)",
	"Máy lọc không khí Daikin MC70MVM6": "Air purifier Daikin MC70MVM6",
	"THÊM VÀO GIỎ HÀNG": "ADD TO CART",
	"HẾT HÀNG": "OUT OF STOCK",
	"Cam kết hàng chính hãng 100%": "100% genuine guarantee",
	"Miễn phí giao hàng từ 500K": "Free delivery from 500K",
	"Đổi trả miễn phí trong 10 ngày": "ĐFree returns in 10 days",
	"Sửa chữa đồng giá 150.000đ.": "Repair with the same price 150,000 VND.",
	"Bảo hành tại nhà.": "Home Warranty.",
	"Điện thoại SAMSUNG Galaxy Note 10+ 12GB/256GB (Bạc)": "SAMSUNG Galaxy Note 10+ 12GB/256GB (Silver)",
	"Hệ điều hành": "Operation system",
	"Thông tin chung": "General information",
	"Bảo hành": "Warranty",
	"24 tháng": "24 months",
	"Mô tả bảo hành": "Warranty Description",
	"Màu sắc": "Color",
	"Bạc": "Silver",
	"Cấu hình chi tiết": "Detailed configuration",
	"src.ProductDetail.mocks.0": "15.6\" ( 1366 x 768 ) HD non-touch, VGA webcam",
	"Cổng kết nối": "Connector",
	"Số cổng lưu trữ tối đa": "Max number of storage ports",
	"Siêu robot hút bụi": "Super robot vacuum cleaner",
	"Tiết kiệm hơn khi mua cùng {{name}}": "Save more when buying together {{name}}",
	"Tiết kiệm:": "Save:",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"Đã áp dụng mã giảm giá": "Discount code applied",
	"giảm": "discount",
	"Xem thêm": "Expand",
	"Thu gọn": "Collapse",
	"Thông số kỹ thuật": "Specification",
	"Giá:": "Price:",
	"Đã giảm thêm": "Discount more",
	"Đã áp dụng": "Applied",
	"Chờ thanh toán": "Waiting for payment",
	"Chờ giao hàng": "Waiting for delivery",
	"Đã hoàn thành": "Completed",
	"{{hours}} giờ": "{{hours}} hour",
	"{{PrimaryName}} và {{var0}} sản phẩm khác": "{{PrimaryName}} and {{var0}} other products",
	"Mặc định": "Default",
	"Xem tất cả": "View all",
	"sản phẩm tặng ngay": "received product",
	"Voucher dùng cho đơn hàng sau": "Voucher for the next order",
	"Mã giảm giá": "Discount code",
	"Bấm để chọn": "Tap to select",
	"Tối đa": "Max",
	"Tất cả": "All",
	"{{ApplySellerIdsLength}} nhà cung cấp": "{{ApplySellerIdsLength}} suppliers",
	"Đơn hàng từ": "Order from",
	"Đơn hàng tối thiểu": "Order from",
	"Đơn hàng dưới": "Order under",
	"Tất cả các đơn hàng": "All orders",
	"(Chỉ áp dụng trên một số sản phẩm nhất định)": "(Applicable for some specific products only)",
	"VNSHOP - mã cho đơn 86WD": "VNSHOP - code for order 86WD",
	"Miễn phí giao hàng cho đơn hàng từ 300K": "Free delivery for the order from 300K",
	"Giảm thêm 10%, tối đa 50k, khi thanh toán VNPAY-QR": "Discount more 10%, max 50k, pay via VNPAY-QR",
	"Đổi trả trong vòng 10 ngày": "Free exchange in 10 days",
	"Mua máy tính - đến Phong Vũ": "Buy a computer - come to Phong Vũ",
	"Hoàn tiền 150% nếu hàng không chính hãng": "150% refund if the item is not genuine",
	"Mua sắm đơn giản hơn": "Shopping more simple",
	"Hàng tiêu dùng Nhật Bản - Thời trang thông minh": "Japanese consumer goods - Smart fashion",
	"Giao hàng nhanh 4h trong nội thành (đặt trước 18:00)": "Fast delivery 4 hours in the inner city (order before 18:00)",
	"An tâm mua sắm mỗi ngày": "Shop with peace of mind every day",
	"Mỹ phẩm chính hãng Hàn Quốc": "Genuine Korean cosmetics",
	"Làn da không tuổi": "Ageless skin",
	"Trung thành với các giá trị cốt lõi": "Loyalty to core values",
	"src.mobile.Cart.CouponSelector.CouponSelector.data.3": "Due to the impact of COVID, Vnshop temporarily suspends delivery activities in Da Nang",
	"Nhà phân phối chính thức của HEAD tennis": "Official distributor of HEAD tennis",
	"Bí quyết cho làn da tươi trẻ": "The secret to youthful skin",
	"Mang đến thiên nhiên cho làn da của bạn": "Bring nature to your skin",
	"Thiên đường mỹ phẩm Hàn Quốc": "Korean cosmetic paradise",
	"Thương hiệu gia dụng cao cấp Châu Âu": "European luxury household brand",
	"Mỹ phẩm chính hãng từ Canada": "Genuine cosmetics from Canada",
	"Mỹ phẩm chính hãng từ Thái Lan": "Genuine cosmetics from Thailand",
	"Thức uống lên men dành cho sức khỏe": "Fermented drink for health",
	"TTC Sugar Chính hãng": "TTC Sugar official",
	"Phát triển bền vững cùng cây mía Việt Nam": "Sustainable development with Vietnamese sugarcane",
	"Thương hiệu siêu thị cao cấp Nhật Bản": "High-end Japanese supermarket brand",
	"Sản phẩm dinh dưỡng nhập khẩu 100% từ Úc": "Nutrition products imported 100% from Australia",
	"Công ty 266": "266 company",
	"Mỹ phẩm trang điểm hữu cơ từ Nhật Bản": "Organic makeup cosmetics from Japan",
	"Mỹ phẩm thiên nhiên thuần khiết": "Pure natural cosmetics",
	"Vì một thế hệ thông minh": "For a smart generation",
	"Sản Phẩm Chính Hãng Từ Pháp": "Genuine Products From France",
	"CÔNG TY CỔ PHẦN VENUS INC VIỆT NAM": "VENUS INC JOINT STOCK COMPANY VIETNAM",
	"Khơi nguồn cảm hứng cho sắc đẹp": "Inspiration for beauty",
	"ÁP DỤNG NGAY 1 MÃ GIẢM GIÁ": "APPLY 1 DISCOUNT CODE NOW",
	"MUA THÊM ĐỂ ÁP DỤNG MÃ": "BUY MORE TO GET DISCOUNT",
	"Nhập mã giảm giá để hưởng ưu đãi": "Enter the discount code to enjoy the offer",
	"Nhập mã giảm giá": "Input discount code",
	"Áp Dụng": "Apply",
	"Không có sản phẩm nào trong giỏ hàng": "No product in the cart",
	"Quà tặng từ {{name}}": "Gift from {{name}}",
	"Đã chọn": "Selected",
	"Nhập thời gian nhận hàng": "Input delivery time",
	"Chưa có đơn hàng nào.": "No order found.",
	"Không tìm thấy dữ liệu": "No data found",
	"Không hỗ trợ file với phần mở rộng này.": "Not support this file extension.",
	"Kích thước file quá lớn": "File size too large",
	"Tổng dung lượng các file quá lớn": "Total file size too large",
	"Quá số lượng file cho phép": "Exceed number of allowed file",
	"Thêm hình ảnh": "Add image",
	"Sắp xếp": "Sort",
	"Kêu gọi mua chung": "Group buy",
	"Còn {{days}} ngày": "Remain {{days}} days",
	"Đơn hàng": "Order",
	"Người": "People",
	"Còn": "Remain",
	"Mã đơn": "Order code",
	"Thanh toán ngay": "Pay now",
	"Giảm giá {{discount}}": "Discount {{discount}}",
	"Quà tặng cho đơn hàng": "Order gift",
	"Chuột chơi game xịn": "Good gaming mouse",
	"Pad chuột": "TouchPad",
	"Chuột chơi game đểu": "Crazy gaming mouse",
	"Qùa tặng cho đơn hàng": "Order gift",
	"Giảm {{PromotionValue}}": "Discount {{PromotionValue}}",
	"src.mobile.ProductCard.ProductCard.0": "This is alcohol included product, please confirm that you are 18 years old to buy this product!",
	"Cảnh báo": "Warning",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tạm hết hàng": "Out of stock",
	"Mô tả sản phẩm": "Description",
	"src.mobile.ProductDetail.ProductShortDescriptionMobile.0": "Description will be updated soon!",
	"Còn lại:": "Remain:",
	"Giờ vàng giá sốc": "Flash sale",
	"Tặng voucher": "Receive voucher",
	"Mã": "Code",
	"{{BenefitPercent}}% tối đa {{var0}}": "{{BenefitPercent}}% max {{var0}}",
	"Bạn sẽ nhận được": "You will receive",
	"Tiết kiệm": "Save",
	"Giảm {{var0}} {{var1}}": "Discount {{var0}} {{var1}}",
	"Chọn thêm 1 trong những khuyến mại sau": "Select 1 of the following promotions",
	"Chi tiết khuyến mãi": "Detailed promotions",
	"Tên chương trình": "Campaign name",
	"Hạn sử dụng": "Expiry date",
	"Đến": "To",
	"Quà khuyến mãi": "Gift",
	"Thương hiệu hàng đầu": "Popular brand",
	"giờ": "hour",
	"ngày": "day",
	"Chỉ còn {{totalAvailableByStocks}} sản phẩm": "Remain {{totalAvailableByStocks}} products",
	"Mua ngay": "Buy now",
	"Mã/phiếu mua hàng": "Coupons/E-vouchers"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/lang/index.es.js



const lang = {
  vi: viLang,
  en: enLang
};
var lang$1 = lang;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Layout/Footer/Footer.es.js + 1 modules
var Footer_es = __webpack_require__(184164);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Tag/Tag.es.js
var Tag_es = __webpack_require__(173698);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/SvgIcon.es.js
var SvgIcon_es = __webpack_require__(46610);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_es = __webpack_require__(650983);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Input/Input.es.js
var Input_es = __webpack_require__(589561);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(179185);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/link.js
var next_link = __webpack_require__(535874);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductGifts/ProductGifts.es.js
var ProductGifts_es = __webpack_require__(811850);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductName/ProductName.es.js
var ProductName_es = __webpack_require__(73586);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/FlashSaleBadge/FlashSaleBadge.es.js + 2 modules
var FlashSaleBadge_es = __webpack_require__(962836);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(770024);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/Loading/Loading.es.js
var Loading_es = __webpack_require__(519209);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductCard/ProductCard.es.js











var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DisplayStatus = {
  NONE: 1,
  CONTACT: 2,
  BUYABLE: 3
};
const StyledProductCard = styled_es/* styled.div */.z.div`
  padding: 0.3rem;
  background: #fff;
  cursor: pointer;
  display: block;
  text-decoration: none;
  color: #333;
  border-radius: 0.5rem;
  height: 100%;
`;
const StyledProductGifts = (0,styled_es/* styled */.z)(ProductGifts_es/* ProductGifts */.W)`
  margin-top: 0.5rem;
`;
const StyledProductName = (0,styled_es/* styled */.z)(ProductName_es/* ProductName */.r)`
  margin-top: 0.5rem;
`;
const StyledTag = (0,styled_es/* styled */.z)(Tag_es/* Tag */.V)`
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
  font-size: 0.65rem;
`;
const ImageWrapper = styled_es/* styled.div */.z.div`
  position: relative;
`;
const Tags = styled_es/* styled.div */.z.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
`;
const FrameWrapper = styled_es/* styled.div */.z.div(({ frame }) => `
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  background-image: url(${frame});
  background-size: cover;
  height: 100%;
  width: 100%;
  `);
const PriceWrapper = styled_es/* styled.div */.z.div`
  display: flex;
  margin-top: 0.5rem;
`;
const Icons = styled_es/* styled.div */.z.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: 0.2rem;
`;
const StyledIcon = (0,styled_es/* styled */.z)(SvgIcon_es/* SvgIcon */.l)`
  margin-left: 0.5rem;
`;
const StyledFlashSaleBadge = (0,styled_es/* styled */.z)(FlashSaleBadge_es/* FlashSaleBadge */.j)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 0;
`;
const Hover = styled_es/* styled.div */.z.div`
  padding: 0.7rem;
  border-radius: 0.5rem;
  transition: transform 0.2s;
  -webkit-font-smoothing: subpixel-antialiased;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  &:hover {
    transform: scale(1.05);
  }
`;
const CustomLink = styled_es/* styled.a */.z.a`
  color: unset;
  text-decoration: unset;
`;
const Contact = styled_es/* styled.div */.z.div(({ theme }) => `
  background-color: ${theme == null ? void 0 : theme.brand.tertiary};
  color: ${theme == null ? void 0 : theme.brand.primary};
  padding: 2px 8px;
  font-size: 0.75rem;
  border-radius: 0.25rem;
  width: fit-content;
  font-weight: 500;
  margin-top: 0.5rem;
`);
const AddToCartBtn = (0,styled_es/* styled */.z)(Button_es/* Button */.z)`
  font-weight: 500;
`;
const QuantityStepper = styled_es/* styled.div */.z.div(({ theme }) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${theme == null ? void 0 : theme.brand.primary};
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  `);
const StyledInput = (0,styled_es/* styled */.z)(Input_es/* Input */.I)(({ theme }) => `
    padding: 0;
    border: none;
    width: 100%;
    text-align: center;
    color: ${theme == null ? void 0 : theme.brand.primary};
  `);
const StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)`
  border: none;
  height: 40px;
`;
const AddToCartWrapper = styled_es/* styled.div */.z.div`
  margin-top: 1rem;
`;
const StyledTagStatus = (0,styled_es/* styled */.z)(Tag_es/* Tag */.V)`
  font-size: 11px;
  border-radius: 4px;
  position: absolute;
  bottom: 0;
  left: 0;
`;
const ProductCard = (_a) => {
  var _b = _a, {
    tags = [],
    image,
    title,
    price,
    link,
    icons = [],
    coupon,
    gifts,
    flashsale,
    money,
    regionName,
    className,
    totalAvailableByStocks,
    displayStatus,
    addToCart,
    needManageStock,
    frame,
    contactLink,
    tag,
    showContact = false
  } = _b, props = __objRest(_b, [
    "tags",
    "image",
    "title",
    "price",
    "link",
    "icons",
    "coupon",
    "gifts",
    "flashsale",
    "money",
    "regionName",
    "className",
    "totalAvailableByStocks",
    "displayStatus",
    "addToCart",
    "needManageStock",
    "frame",
    "contactLink",
    "tag",
    "showContact"
  ]);
  const [qty, setQty] = (0,react.useState)(() => addToCart && addToCart.quantityInCart || 0);
  const [loading, setLoading] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    if (addToCart && !loading)
      setQty(addToCart.quantityInCart || 0);
  }, [addToCart, loading]);
  const handleUpdateQty = async () => {
    if (qty && qty !== (addToCart == null ? void 0 : addToCart.quantityInCart)) {
      setLoading(true);
      await (addToCart == null ? void 0 : addToCart.onChangeQuantity(qty));
      setLoading(false);
    } else {
      setQty((addToCart == null ? void 0 : addToCart.quantityInCart) || 0);
    }
  };
  const node = /* @__PURE__ */ react.createElement(Hover, {
    className: "product-card__content"
  }, /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(ImageWrapper, null, frame && /* @__PURE__ */ react.createElement(FrameWrapper, {
    frame
  }), /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, __spreadProps(__spreadValues({
    imageWidth: 320,
    borderRadius: 8,
    contain: true
  }, image), {
    aspectRatio: 1
  })), flashsale && /* @__PURE__ */ react.createElement(StyledFlashSaleBadge, {
    size: "md",
    endAt: flashsale.endAt,
    sold: flashsale.value,
    total: flashsale.total,
    stock: totalAvailableByStocks
  }), !!tags.length && !flashsale && /* @__PURE__ */ react.createElement(Tags, null, tags.map((tag2, index) => /* @__PURE__ */ react.createElement(StyledTag, {
    key: index,
    outline: true
  }, tag2))), !flashsale && tag && /* @__PURE__ */ react.createElement(StyledTagStatus, __spreadValues({}, tag))), /* @__PURE__ */ react.createElement("div", {
    className: "product-card__info"
  }, /* @__PURE__ */ react.createElement(StyledProductName, {
    needManageStock,
    totalAvailableByStocks,
    name: title.name,
    isFlashSelling: flashsale !== null
  }), totalAvailableByStocks > 0 || displayStatus !== DisplayStatus.CONTACT ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(PriceWrapper, null, /* @__PURE__ */ react.createElement(ProductPrice_es/* ProductPrice */.j, {
    price: price.price,
    listedPrice: price.listedPrice,
    discount: price.discount
  }), /* @__PURE__ */ react.createElement(Icons, null, icons.map((icon, index) => /* @__PURE__ */ react.createElement(StyledIcon, __spreadValues({
    key: index
  }, icon))))), gifts && /* @__PURE__ */ react.createElement(StyledProductGifts, {
    label: (0,i18n_es.t)("QU\xC0 T\u1EB6NG"),
    images: gifts.images
  })) : /* @__PURE__ */ react.createElement(react.Fragment, null, displayStatus === DisplayStatus.CONTACT ? /* @__PURE__ */ react.createElement(Contact, null, (0,i18n_es.t)("LI\xCAN H\u1EC6")) : /* @__PURE__ */ react.createElement(Tag_es/* Tag */.V, {
    outline: true
  }, displayStatus)))), addToCart && /* @__PURE__ */ react.createElement(AddToCartWrapper, null, !!addToCart.quantityInCart ? /* @__PURE__ */ react.createElement(QuantityStepper, null, /* @__PURE__ */ react.createElement(Loading_es/* Loading */.g, {
    isLoading: loading
  }, /* @__PURE__ */ react.createElement(StyledButton, {
    onClick: (e) => {
      e.preventDefault();
      addToCart.onDecrease();
    },
    outline: true,
    block: true,
    variant: "primary"
  }, /* @__PURE__ */ react.createElement(SvgIcon_es/* SvgIcon */.l, {
    name: "subtract",
    themeColor: "primary",
    size: 22
  })), /* @__PURE__ */ react.createElement(StyledInput, {
    value: qty || "",
    onClick: (e) => e.preventDefault(),
    onChange: (e) => setQty(Number(e.target.value)),
    type: "number",
    onBlur: handleUpdateQty,
    onKeyDown: (e) => {
      if (e.key === "Enter")
        handleUpdateQty();
    }
  }), /* @__PURE__ */ react.createElement(StyledButton, {
    onClick: (e) => {
      e.preventDefault();
      addToCart.onIncrease();
    },
    outline: true,
    block: true,
    variant: "primary"
  }, /* @__PURE__ */ react.createElement(SvgIcon_es/* SvgIcon */.l, {
    name: "plus",
    themeColor: "primary",
    size: 22
  })))) : /* @__PURE__ */ react.createElement(AddToCartBtn, {
    onClick: (e) => {
      e.preventDefault();
      if (showContact) {
        if (contactLink)
          window.open(contactLink);
        return;
      }
      addToCart.onAddToCart();
    },
    size: "lg",
    disabled: !!(showContact && !contactLink),
    variant: showContact && !contactLink ? "disabled" : "primary",
    outline: true,
    block: true
  }, showContact ? contactLink ? (0,i18n_es.t)("Li\xEAn h\u1EC7") : (0,i18n_es.t)("H\u1EBFt h\xE0ng") : (0,i18n_es.t)("Th\xEAm v\xE0o gi\u1ECF"))));
  if (link) {
    return /* @__PURE__ */ react.createElement((link_default()), __spreadProps(__spreadValues({}, link), {
      legacyBehavior: true
    }), /* @__PURE__ */ react.createElement(CustomLink, __spreadProps(__spreadValues({}, props), {
      className: className || ""
    }), /* @__PURE__ */ react.createElement(StyledProductCard, __spreadValues({
      className: "product-card"
    }, regionName && (0,helper_es/* getTrackingData */.O5)({
      isTrackContent: true,
      regionName,
      contentName: props.sku,
      target: "productDetail"
    })), node)));
  }
  return /* @__PURE__ */ react.createElement(StyledProductCard, __spreadValues(__spreadProps(__spreadValues({}, props), {
    className: `${className || ""} product-card`
  }), regionName && (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName,
    contentName: props.sku,
    target: "productDetail"
  })), node);
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/reflexbox-virtual-62ae8f912b/0/cache/reflexbox-npm-4.0.6-201af1058c-b532551c8b.zip/node_modules/reflexbox/dist/index.js
var dist = __webpack_require__(504545);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(528938);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/FeaturedBanners/FeaturedBanners.es.js






var FeaturedBanners_es_defProp = Object.defineProperty;
var FeaturedBanners_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var FeaturedBanners_es_hasOwnProp = Object.prototype.hasOwnProperty;
var FeaturedBanners_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var FeaturedBanners_es_defNormalProp = (obj, key, value) => key in obj ? FeaturedBanners_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var FeaturedBanners_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (FeaturedBanners_es_hasOwnProp.call(b, prop))
      FeaturedBanners_es_defNormalProp(a, prop, b[prop]);
  if (FeaturedBanners_es_getOwnPropSymbols)
    for (var prop of FeaturedBanners_es_getOwnPropSymbols(b)) {
      if (FeaturedBanners_es_propIsEnum.call(b, prop))
        FeaturedBanners_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var FeaturedBanners_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (FeaturedBanners_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && FeaturedBanners_es_getOwnPropSymbols)
    for (var prop of FeaturedBanners_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && FeaturedBanners_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const FeaturedBanners = (_a) => {
  var _b = _a, {
    banners,
    regionName
  } = _b, props = FeaturedBanners_es_objRest(_b, [
    "banners",
    "regionName"
  ]);
  var _a2, _b2;
  let bannerHeight = 140;
  if (!banners || !banners.length)
    return null;
  if ((_b2 = (_a2 = banners[0]) == null ? void 0 : _a2.imageSize) == null ? void 0 : _b2.height) {
    bannerHeight = Number(banners[0].imageSize.height);
  }
  return /* @__PURE__ */ react.createElement(dist/* Flex */.kC, FeaturedBanners_es_spreadValues(FeaturedBanners_es_spreadValues({
    mx: -2
  }, props), {
    "content-visibility": "auto",
    "contain-intrinsic-size": `${bannerHeight}px`
  }), banners.map((banner, index) => {
    return /* @__PURE__ */ react.createElement(dist/* Box */.xu, FeaturedBanners_es_spreadValues({
      px: 2,
      width: 1 / banners.length,
      key: index
    }, regionName && (0,helper_es/* getTrackingData */.O5)({
      isTrackContent: true,
      regionName,
      contentName: banner.campaignName,
      target: banner.targetPath,
      index
    })), /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, {
      targetPath: banner.targetPath
    }, /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
      borderRadius: 8,
      hover: "zoom",
      height: bannerHeight,
      alt: `banner-${index}`,
      src: banner.image,
      imageWidth: Math.ceil(1232 / banners.length)
    })));
  }));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/Article/Article.es.js
var Article_es = __webpack_require__(551165);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Card/Card.es.js
var Card_es = __webpack_require__(797864);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/BlockHeader/BlockHeader.es.js
var BlockHeader_es = __webpack_require__(918358);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Row/Row.es.js
var Row_es = __webpack_require__(995667);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Col/Col.es.js
var Col_es = __webpack_require__(865237);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Pagination/Pagination.es.js
var Pagination_es = __webpack_require__(85468);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductReview/mock.es.js


const reviewMock = {
  items: [
    {
      rating: 4,
      comment: (0,i18n_es.t)("ch\xE0 c\xE0 r\xF4n"),
      createdAt: "2020-04-24T03:38:33"
    }
  ],
  statisticVotes: { 1: 0, 2: 0, 3: 0, 4: 1, 5: 0 },
  average: 4,
  totalRating: 1
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductReview/components/RatingStars/RatingStars.es.js



const RatingStars_es_StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)(({ readOnly }) => `
  padding: 0px;
  pointer-events: ${readOnly ? "none" : "auto"};
`);
const RatingStars = ({
  stars,
  onStarClicked,
  starWidth = 12,
  readOnly = false,
  className
}) => {
  const [rating, setRating] = (0,react.useState)(stars);
  const clickStar = (star) => {
    setRating(star);
    onStarClicked && onStarClicked(star);
  };
  (0,react.useEffect)(() => {
    setRating(stars);
  }, [stars]);
  return /* @__PURE__ */ react.createElement("div", {
    className
  }, Array.from(Array(5).keys()).map((i) => {
    return /* @__PURE__ */ react.createElement(RatingStars_es_StyledButton, {
      key: `star-${i}`,
      icon: {
        name: "star",
        size: starWidth,
        color: i <= Math.round(rating - 1) ? "#ffd124" : "#d2d2d2"
      },
      link: true,
      block: false,
      disabled: readOnly,
      onClick: () => clickStar(i + 1),
      readOnly
    });
  }));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProgressBar/ProgressBar.es.js



const StyledBar = styled_es/* styled.div */.z.div(({ barHeight, barBorder }) => `
  height: ${barHeight}px;
  border-radius: ${barBorder}px;
  background-color: #d2d2d2;
  margin-left: 8px;
  position: relative;
`);
const Progress = styled_es/* styled.div */.z.div(({ height, border, progressPercentage, theme, color }) => {
  return `
  background-color: ${color || (theme == null ? void 0 : theme.brand.primary)};
  position: absolute;
  z-index: 1;
  height: inherit;
  border-radius: ${border}px;
  height: ${height}px;
  width: ${progressPercentage}%;
`;
});
const ProgressBar = ({
  progress = 0,
  barColor,
  barHeight = 4,
  barBorder = 2
}) => {
  return /* @__PURE__ */ react.createElement(StyledBar, {
    barHeight,
    barBorder
  }, /* @__PURE__ */ react.createElement(Progress, {
    progressPercentage: progress,
    color: barColor,
    height: barHeight,
    border: barBorder
  }));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductReview/components/RatingStatistic/RatingStatistic.es.js





const StyledRatingStars = (0,styled_es/* styled */.z)(Col_es/* Col */.J)`
  padding-right: 0px;
  min-width: 80px;
`;
const StyledProgressBar = (0,styled_es/* styled */.z)(Col_es/* Col */.J)(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.gray600};
  font-size: 12px;
  padding-left: 0px;
`);
const VoteCountCol = (0,styled_es/* styled */.z)(Col_es/* Col */.J)`
  padding-top: 6px;
`;
const StyledCol = (0,styled_es/* styled */.z)(Col_es/* Col */.J)`
  text-align: right;
`;
const calculatePercent = (use, total) => {
  return 100 * use / total || 0;
};
const RatingStatistic = ({
  stars,
  voteCount,
  totalRating
}) => {
  return /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Row_es/* Row */.X, null, /* @__PURE__ */ react.createElement(StyledRatingStars, {
    col: 3.5
  }, /* @__PURE__ */ react.createElement(RatingStars, {
    stars,
    readOnly: true
  })), /* @__PURE__ */ react.createElement(StyledProgressBar, {
    col: 8.5
  }, /* @__PURE__ */ react.createElement(Row_es/* Row */.X, null, /* @__PURE__ */ react.createElement(VoteCountCol, {
    col: 9.5
  }, /* @__PURE__ */ react.createElement(ProgressBar, {
    barHeight: 4,
    progress: calculatePercent(voteCount, totalRating),
    barColor: "rgb(95, 231, 255)"
  })), /* @__PURE__ */ react.createElement(StyledCol, {
    col: 2.5
  }, /* @__PURE__ */ react.createElement("span", null, voteCount))))));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductReview/components/OverallRating/OverallRating.es.js






const Average = styled_es/* styled.div */.z.div`
  font-weight: 500;
  font-size: 36px;
`;
const Total = styled_es/* styled.span */.z.span`
  color: #b4b4b4;
`;
const TotalComment = styled_es/* styled.div */.z.div`
  font-size: 14px;
  margin-bottom: 24px;
  color: #848788;
`;
const VoteCount = styled_es/* styled.span */.z.span`
  color: #333333;
`;
const OverallRating = ({
  average,
  totalRating,
  statisticVotes
}) => {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, average ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Average, null, average, /* @__PURE__ */ react.createElement(Total, null, "/5")), /* @__PURE__ */ react.createElement(RatingStars, {
    stars: average,
    readOnly: true,
    starWidth: 20
  }), /* @__PURE__ */ react.createElement(TotalComment, null, (0,i18n_es.t)("Trung b\xECnh c\u1EE7a:"), /* @__PURE__ */ react.createElement(VoteCount, null, " ", totalRating, (0,i18n_es.t)("nh\u1EADn x\xE9t")))) : /* @__PURE__ */ react.createElement("div", {
    className: "mb26"
  }, (0,i18n_es.t)("Ch\u01B0a c\xF3 \u0111\xE1nh gi\xE1 n\xE0o")), /* @__PURE__ */ react.createElement(react.Fragment, null, Array.from(Array(5).keys()).reverse().map((i) => {
    return /* @__PURE__ */ react.createElement(RatingStatistic, {
      key: `rating-statistic-${i}`,
      stars: i + 1,
      voteCount: statisticVotes[i + 1],
      totalRating
    });
  })));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductReview/components/ReviewForm/ReviewForm.es.js





const Divider = styled_es/* styled.hr */.z.hr`
  margin: 0 16px;
  width: 90%;
`;
const Form = styled_es/* styled.div */.z.div`
  padding: 15px;
  margin: 0 auto;
  margin-top: 30px;
  border-radius: 10px;
  background-color: #f6f6f6;
  width: 100%;
`;
const CommentTitle = styled_es/* styled.div */.z.div`
  height: 19px;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.11px;
  color: #000000;
  margin-bottom: 13px;
`;
const InputGroup = styled_es/* styled.div */.z.div`
  display: block;
  margin-top: 15px;
`;
const FormLabel = styled_es/* styled.label */.z.label`
  width: 200px;
`;
const CommentBox = styled_es/* styled.textarea */.z.textarea`
  flex: 1;
  border-radius: 3px;
  padding: 0;
  outline: none;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  font-size: 14px;
  background-color: white;
  line-height: 1.5;
  &::-webkit-input-placeholder {
    font-size: 12px;
    color: #999;
  }
  border: solid 1px #e0e0e0;
  width: 100%;
  resize: none;
`;
const ReviewForm_es_StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)(({ theme }) => `
  margin-top: 24px;
  width: 100%;
  background: ${theme == null ? void 0 : theme.brand.primary};
  color: #fff;
  padding: 12px;
  &:hover {
    color: ${theme == null ? void 0 : theme.brand.primary};
    background: #fff;
  }
  text-align: center;
  justify-content: center;
`);
const ReviewForm = ({
  onSendRating
}) => {
  const [rating, setRating] = (0,react.useState)(-1);
  const [comment, setComment] = (0,react.useState)("");
  const handleAddComment = (e) => {
    setComment(e.target.value);
  };
  return /* @__PURE__ */ react.createElement(Form, null, /* @__PURE__ */ react.createElement(CommentTitle, null, (0,i18n_es.t)("Nh\u1EADn x\xE9t c\u1EE7a b\u1EA1n")), /* @__PURE__ */ react.createElement(Divider, null), /* @__PURE__ */ react.createElement(InputGroup, null, /* @__PURE__ */ react.createElement(FormLabel, null, (0,i18n_es.t)("1. \u0110\xE1nh gi\xE1 v\u1EC1 s\u1EA3n ph\u1EA9m:")), /* @__PURE__ */ react.createElement(RatingStars, {
    stars: -1,
    onStarClicked: (star) => setRating(star),
    starWidth: 20
  })), /* @__PURE__ */ react.createElement(InputGroup, null, /* @__PURE__ */ react.createElement(FormLabel, null, (0,i18n_es.t)("2. Vi\u1EBFt nh\u1EADn x\xE9t:")), /* @__PURE__ */ react.createElement(CommentBox, {
    value: comment,
    onChange: handleAddComment,
    rows: 5,
    placeholder: (0,i18n_es.t)("Nh\u1EADn x\xE9t v\u1EC1 s\u1EA3n ph\u1EA9m")
  }, comment)), /* @__PURE__ */ react.createElement(ReviewForm_es_StyledButton, {
    onClick: () => onSendRating(rating, comment)
  }, /* @__PURE__ */ react.createElement("strong", null, (0,i18n_es.t)("G\u1EEDi nh\u1EADn x\xE9t"))));
};



// EXTERNAL MODULE: ../../.yarn/cache/date-fns-npm-2.28.0-c19c5add1b-a0516b2e4f.zip/node_modules/date-fns/esm/format/index.js + 2 modules
var format = __webpack_require__(883667);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/FormattedTime/FormattedTime.es.js



const FormattedTime = ({
  time
}) => {
  return /* @__PURE__ */ react.createElement("span", null, (0,format/* default */.Z)(new Date(time.dateTime), time.timeFormat));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductReview/components/ReviewLine/ReviewLine.es.js





const RateItem = styled_es/* styled.div */.z.div`
  display: flex;
  padding: 24px;
`;
const UserInfo = styled_es/* styled.div */.z.div`
  display: flex;
  width: 25%;
`;
const CustomerName = styled_es/* styled.div */.z.div`
  font-size: 1rem;
  font-weight: 500;
`;
const RatingTime = styled_es/* styled.div */.z.div`
  color: #848788;
`;
const ReviewContent = styled_es/* styled.div */.z.div`
  line-height: 20px;
  width: 75%;
`;
const StyledButtonIcon = (0,styled_es/* styled */.z)(Button_es/* Button */.z)`
  width: 80px;
  .title {
    font-size: 12px;
  }
`;
const ReviewLine_es_Divider = styled_es/* styled.hr */.z.hr`
  width: 90%;
  margin: 0 auto;
`;
const ReviewLine = ({
  avatar,
  userName,
  title,
  comment,
  rating,
  time
}) => {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(RateItem, null, /* @__PURE__ */ react.createElement(UserInfo, null, !avatar ? /* @__PURE__ */ react.createElement(StyledButtonIcon, {
    icon: { name: "account", size: 32 },
    link: true
  }) : /* @__PURE__ */ react.createElement("img", {
    src: avatar,
    alt: "avatar"
  }), /* @__PURE__ */ react.createElement("div", {
    className: "ml8"
  }, /* @__PURE__ */ react.createElement(CustomerName, null, userName), time && /* @__PURE__ */ react.createElement(RatingTime, null, /* @__PURE__ */ react.createElement(FormattedTime, {
    time: { dateTime: time, timeFormat: "dd/MM/yyyy HH:mm:ss" }
  })))), /* @__PURE__ */ react.createElement(ReviewContent, null, /* @__PURE__ */ react.createElement(RatingStars, {
    stars: rating,
    readOnly: true
  }), /* @__PURE__ */ react.createElement("div", null, title), /* @__PURE__ */ react.createElement("div", null, comment))), /* @__PURE__ */ react.createElement(ReviewLine_es_Divider, null));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductReview/ProductReview.es.js








const ReviewWrapper = styled_es/* styled.div */.z.div``;
const StyledContainer = styled_es/* styled.div */.z.div`
  border-top: 1px solid rgb(224, 224, 224);
  padding: 16px;
`;
const StyledPaginationBlock = styled_es/* styled.div */.z.div`
  position: relative;
  width: fit-content;
  margin-left: auto;
  margin-right: 20px;
  padding-bottom: 20px;
`;
const ProductReview = ({
  review = reviewMock,
  showForm = false,
  onSendRating,
  ratingPage,
  onPageChanged,
  pageLimit = 10
}) => {
  return /* @__PURE__ */ react.createElement(Card_es/* Card */.Z, null, /* @__PURE__ */ react.createElement(ReviewWrapper, null, /* @__PURE__ */ react.createElement(BlockHeader_es/* BlockHeader */.t, {
    title: (0,i18n_es.t)("Nh\u1EADn x\xE9t v\xE0 \u0111\xE1nh gi\xE1")
  }), /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(Row_es/* Row */.X, null, /* @__PURE__ */ react.createElement(Col_es/* Col */.J, {
    col: 3
  }, /* @__PURE__ */ react.createElement(OverallRating, {
    average: review.average,
    totalRating: review.totalRating,
    statisticVotes: review.statisticVotes
  }), showForm && /* @__PURE__ */ react.createElement(ReviewForm, {
    onSendRating: (rating, comment) => onSendRating(rating, comment)
  })), /* @__PURE__ */ react.createElement(Col_es/* Col */.J, {
    col: 9
  }, review && review.totalRating > 0 && review.items.map((item) => {
    return /* @__PURE__ */ react.createElement(ReviewLine, {
      key: item.createdAt,
      rating: item.rating,
      comment: item.comment,
      time: item.createdAt
    });
  })))), review && review.totalRating > 0 && /* @__PURE__ */ react.createElement(StyledPaginationBlock, null, /* @__PURE__ */ react.createElement(Pagination_es/* Pagination */.t, {
    totalRecords: review.totalRating,
    pageLimit,
    onPageChanged: (page) => onPageChanged(page),
    currentPage: ratingPage
  }))));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/SelectOption/SelectOption.es.js
var SelectOption_es = __webpack_require__(217622);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/Logo/Logo.es.js
var Logo_es = __webpack_require__(775768);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductsGrid/ProductsGrid.es.js




var ProductsGrid_es_defProp = Object.defineProperty;
var ProductsGrid_es_defProps = Object.defineProperties;
var ProductsGrid_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var ProductsGrid_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var ProductsGrid_es_hasOwnProp = Object.prototype.hasOwnProperty;
var ProductsGrid_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var ProductsGrid_es_defNormalProp = (obj, key, value) => key in obj ? ProductsGrid_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var ProductsGrid_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (ProductsGrid_es_hasOwnProp.call(b, prop))
      ProductsGrid_es_defNormalProp(a, prop, b[prop]);
  if (ProductsGrid_es_getOwnPropSymbols)
    for (var prop of ProductsGrid_es_getOwnPropSymbols(b)) {
      if (ProductsGrid_es_propIsEnum.call(b, prop))
        ProductsGrid_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var ProductsGrid_es_spreadProps = (a, b) => ProductsGrid_es_defProps(a, ProductsGrid_es_getOwnPropDescs(b));
const StyledProductsGrid = styled_es/* styled.div */.z.div`
  display: flex;
  flex-wrap: wrap;
`;
const ProductsGrid_es_StyledProductCard = (0,styled_es/* styled */.z)(ProductCard)`
  box-sizing: border-box;
  width: ${(props) => 100 / props.productsPerRow}%;
  border-radius: 0.5rem;
`;
const Line = styled_es/* styled.div */.z.div`
  width: 100%;
  height: 1px;
  margin-top: 16px;
  margin-bottom: 16px;
  background-color: #e0e0e0;
`;
const ProductsGrid = ({
  products = [],
  productsPerRow = 5,
  regionName
}) => {
  return /* @__PURE__ */ react.createElement(Card_es/* Card */.Z, null, /* @__PURE__ */ react.createElement(StyledProductsGrid, null, products.map((product, index) => /* @__PURE__ */ react.createElement(react.Fragment, {
    key: index
  }, /* @__PURE__ */ react.createElement(ProductsGrid_es_StyledProductCard, ProductsGrid_es_spreadProps(ProductsGrid_es_spreadValues({
    productsPerRow,
    key: product.sku
  }, product), {
    regionName
  })), index % productsPerRow === productsPerRow - 1 && index !== products.length - 1 && /* @__PURE__ */ react.createElement(Line, null)))));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/NoProductsFound/NoProductsFound.es.js
var NoProductsFound_es = __webpack_require__(980424);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ListTile/ListTile.es.js
var ListTile_es = __webpack_require__(469100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/Text/Text.es.js
var Text_es = __webpack_require__(327513);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/SearchSuggestions/SearchSuggestions.es.js







var SearchSuggestions_es_defProp = Object.defineProperty;
var SearchSuggestions_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var SearchSuggestions_es_hasOwnProp = Object.prototype.hasOwnProperty;
var SearchSuggestions_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var SearchSuggestions_es_defNormalProp = (obj, key, value) => key in obj ? SearchSuggestions_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var SearchSuggestions_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (SearchSuggestions_es_hasOwnProp.call(b, prop))
      SearchSuggestions_es_defNormalProp(a, prop, b[prop]);
  if (SearchSuggestions_es_getOwnPropSymbols)
    for (var prop of SearchSuggestions_es_getOwnPropSymbols(b)) {
      if (SearchSuggestions_es_propIsEnum.call(b, prop))
        SearchSuggestions_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SearchSuggestion = styled_es/* styled.div */.z.div`
  position: absolute;
  background: #fff;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0.8rem;
  display: ${(props) => props.show ? "block" : "none"};
`;
const StyledListTile = (0,styled_es/* styled */.z)(ListTile_es/* ListTile */.x)`
  border-radius: 8px;
`;
const StyledSearchTitle = styled_es/* styled.div */.z.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0;
`;
const StyledRecommendedKeyword = styled_es/* styled.div */.z.div`
  margin: 8px 0 4px;
`;
const ListTerm = styled_es/* styled.div */.z.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  column-gap: 8px;
  row-gap: 8px;
`;
const TermItem = styled_es/* styled.div */.z.div`
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  padding: 0 8px;
  border-radius: 4px;
  border: 1px solid #e4e5f0;
  font-size: 13px;
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
`;
const StyledSearchIcon = (0,styled_es/* styled */.z)(SvgIcon_es/* SvgIcon */.l)`
  margin-right: 8px;
  min-width: 20px;
`;
const SearchSuggestions = ({
  suggestions,
  selected = null,
  onHoverItem,
  onClick,
  show,
  popularKeywords = [],
  showPopularKeywords = false
}) => {
  const renderRecommendedKeyword = () => {
    if (typeof window !== "undefined" && showPopularKeywords && popularKeywords.length > 0)
      return /* @__PURE__ */ react.createElement(StyledRecommendedKeyword, null, /* @__PURE__ */ react.createElement(StyledSearchTitle, null, /* @__PURE__ */ react.createElement(Text_es/* Text */.x, {
        fontWeight: "500",
        textTransform: "uppercase",
        color: "#82869E"
      }, (0,i18n_es.t)("T\u1EEB kh\xF3a ph\u1ED5 bi\u1EBFn"))), /* @__PURE__ */ react.createElement(ListTerm, null, popularKeywords.map((term, index) => {
        return /* @__PURE__ */ react.createElement(TermItem, SearchSuggestions_es_spreadValues({
          onClick: () => onClick(term),
          key: `popularKeyword${index}`
        }, (0,helper_es/* getTrackingData */.O5)({
          isTrackContent: true,
          regionName: "popularKeyword",
          contentName: term,
          index
        })), /* @__PURE__ */ react.createElement(StyledSearchIcon, {
          name: "search",
          size: 20
        }), /* @__PURE__ */ react.createElement(Text_es/* Text */.x, {
          maxLines: 1
        }, term));
      })));
  };
  return /* @__PURE__ */ react.createElement(SearchSuggestion, {
    show: show && (suggestions.length > 0 || popularKeywords.length > 0 && showPopularKeywords)
  }, suggestions.length > 0 && /* @__PURE__ */ react.createElement(react.Fragment, null, suggestions.every((s) => s.icon === "time-outline") && /* @__PURE__ */ react.createElement(StyledSearchTitle, null, /* @__PURE__ */ react.createElement(Text_es/* Text */.x, {
    fontWeight: "500",
    textTransform: "uppercase",
    color: "#82869E"
  }, (0,i18n_es.t)("L\u1ECBch s\u1EED t\xECm ki\u1EBFm"))), suggestions.map((suggestionItem, index) => {
    const regionName = suggestionItem.icon === "time-outline" ? "recentlySearch" : "popularKeyword";
    return /* @__PURE__ */ react.createElement(StyledListTile, SearchSuggestions_es_spreadValues({
      selected: index === selected,
      key: `recentlySearch${index}`,
      leading: /* @__PURE__ */ react.createElement(SvgIcon_es/* SvgIcon */.l, {
        name: suggestionItem.icon,
        size: 20
      }),
      title: suggestionItem.keyword,
      onClick: () => onClick(suggestionItem.keyword),
      onMouseEnter: () => onHoverItem(index),
      type: "search-suggestion"
    }, (0,helper_es/* getTrackingData */.O5)({
      isTrackContent: true,
      regionName,
      contentName: suggestionItem.keyword,
      index
    })));
  })), renderRecommendedKeyword());
};



// EXTERNAL MODULE: ../../.yarn/cache/styled-system-npm-5.1.5-64d59c22e4-e1345f88e0.zip/node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(479690);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/Breadcrumb/Breadcrumb.es.js




var Breadcrumb_es_defProp = Object.defineProperty;
var Breadcrumb_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Breadcrumb_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Breadcrumb_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Breadcrumb_es_defNormalProp = (obj, key, value) => key in obj ? Breadcrumb_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Breadcrumb_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Breadcrumb_es_hasOwnProp.call(b, prop))
      Breadcrumb_es_defNormalProp(a, prop, b[prop]);
  if (Breadcrumb_es_getOwnPropSymbols)
    for (var prop of Breadcrumb_es_getOwnPropSymbols(b)) {
      if (Breadcrumb_es_propIsEnum.call(b, prop))
        Breadcrumb_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Breadcrumb_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Breadcrumb_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Breadcrumb_es_getOwnPropSymbols)
    for (var prop of Breadcrumb_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Breadcrumb_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled_es/* styled.div */.z.div(index_esm.space, `
    white-space: nowrap;
    display: flex;
  `);
const BreadcrumbBlock = styled_es/* styled.div */.z.div`
  height: 32px;
  width: fit-content;
  align-items: center;
  display: flex;
  justify-content: center;
  white-space: nowrap;
`;
const Breadcrumb_es_StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)(({ isDisable, color, outline }) => `
  padding: ${outline ? "8px" : "4px"};
  color: ${isDisable ? "rgba(0,0,0,.38)" : color};
  text-decoration: none;
  background-color: #FFF;
  pointer-events: ${isDisable ? "none" : "auto"};
  border: ${outline ? "1px solid #e0e0e0" : "none"};
  border-radius: 9999px;
  --button-icon-color: ${color};
  &:hover {
    color: ${color};
    background-color: #FFF;
    --button-icon-color: ${color};
  }
   `);
const Breadcrumb_es_Divider = styled_es/* styled.span */.z.span`
  margin: 0 8px;
  color: #9b9b9b;
  font-size: inherit;
`;
const Breadcrumb = (_a) => {
  var _b = _a, {
    items,
    divider,
    color = "#848788",
    outline
  } = _b, props = Breadcrumb_es_objRest(_b, [
    "items",
    "divider",
    "color",
    "outline"
  ]);
  return /* @__PURE__ */ react.createElement(Wrapper, Breadcrumb_es_spreadValues({}, props), items.map((breadcrumb, index) => {
    return /* @__PURE__ */ react.createElement(BreadcrumbBlock, {
      key: index
    }, /* @__PURE__ */ react.createElement(Breadcrumb_es_StyledButton, {
      icon: breadcrumb.icon,
      link: true,
      outline,
      color,
      isDisable: breadcrumb.disabled,
      href: breadcrumb.href,
      tag: "a"
    }, breadcrumb.text), index !== items.length - 1 && /* @__PURE__ */ react.createElement(Breadcrumb_es_Divider, null, divider));
  }));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/Invoice/Invoices.es.js
var Invoices_es = __webpack_require__(155361);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/Invoice/OrderDetailInvoices.es.js
var OrderDetailInvoices_es = __webpack_require__(175233);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/MiniDropdown/MiniDropdown.es.js
var MiniDropdown_es = __webpack_require__(72217);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/Loading/LogoLoading.es.js + 1 modules
var LogoLoading_es = __webpack_require__(465385);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/JDDropdown/JDDropdown.es.js
var JDDropdown_es = __webpack_require__(786273);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/SideNav/SideNav.es.js





var SideNav_es_defProp = Object.defineProperty;
var SideNav_es_defProps = Object.defineProperties;
var SideNav_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var SideNav_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var SideNav_es_hasOwnProp = Object.prototype.hasOwnProperty;
var SideNav_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var SideNav_es_defNormalProp = (obj, key, value) => key in obj ? SideNav_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var SideNav_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (SideNav_es_hasOwnProp.call(b, prop))
      SideNav_es_defNormalProp(a, prop, b[prop]);
  if (SideNav_es_getOwnPropSymbols)
    for (var prop of SideNav_es_getOwnPropSymbols(b)) {
      if (SideNav_es_propIsEnum.call(b, prop))
        SideNav_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var SideNav_es_spreadProps = (a, b) => SideNav_es_defProps(a, SideNav_es_getOwnPropDescs(b));
var SideNav_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (SideNav_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && SideNav_es_getOwnPropSymbols)
    for (var prop of SideNav_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && SideNav_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const List = styled_es/* styled.ul */.z.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;
const SideNav_es_StyledListTile = (0,styled_es/* styled */.z)(ListTile_es/* ListTile */.x)(({ theme, active, hover = true, cursor = true }) => `
    cursor: ${cursor ? "pointer" : "default"};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 0;
    margin: 8px 0;
    background: unset;

    ${active ? `
      font-weight: 700 !important;
      color: ${theme == null ? void 0 : theme.brand.primary} !important;
      > :not(.noti) path {
        fill: ${theme == null ? void 0 : theme.brand.primary};
      }
      > .noti path{
        stroke: ${theme == null ? void 0 : theme.brand.primary};
      }
    ` : hover ? `
      &:hover, .active {
        font-weight: 700 !important;
        color: ${theme == null ? void 0 : theme.brand.primary} !important;
        > :not(.noti) path {
          fill: ${theme == null ? void 0 : theme.brand.primary};
        }
        > .noti path{
          stroke: ${theme == null ? void 0 : theme.brand.primary};
        }
      }` : `&:hover { background-color: unset; }`}
  `);
const SideNav_es_Divider = styled_es/* styled.li */.z.li`
  background-color: #e0e0e0;
  width: 100%;
  height: 1px;
  list-style: none;
`;
const StyledA = styled_es/* styled.a */.z.a`
  text-decoration: none;
`;
const renderNode = (props) => {
  const {
    icon,
    text,
    href,
    fallbackHref,
    children = [],
    activeHref,
    index
  } = props;
  const nodeHasChildren = !!children.length;
  const node = /* @__PURE__ */ react.createElement(SideNav_es_StyledListTile, SideNav_es_spreadValues({
    leading: icon,
    title: text,
    active: !nodeHasChildren && (href === activeHref || !!index && !!href && !!(activeHref == null ? void 0 : activeHref.startsWith(href)) || fallbackHref === activeHref)
  }, nodeHasChildren ? { cursor: false, hover: false } : {}));
  return !!href ? /* @__PURE__ */ react.createElement((link_default()), {
    href,
    legacyBehavior: true
  }, /* @__PURE__ */ react.createElement(StyledA, null, node)) : node;
};
const SideNav = (_a) => {
  var _b = _a, {
    navItems,
    activeHref,
    parentMenuHighlight = true
  } = _b, props = SideNav_es_objRest(_b, [
    "navItems",
    "activeHref",
    "parentMenuHighlight"
  ]);
  return /* @__PURE__ */ react.createElement(List, SideNav_es_spreadValues({}, props), navItems.map((_a2, index) => {
    var _b2 = _a2, { children, href } = _b2, rest = SideNav_es_objRest(_b2, ["children", "href"]);
    return /* @__PURE__ */ react.createElement(react.Fragment, {
      key: index
    }, renderNode(SideNav_es_spreadProps(SideNav_es_spreadValues({}, rest), {
      href: !parentMenuHighlight && !!(children == null ? void 0 : children.length) ? "" : href,
      children,
      activeHref,
      index
    })), !!(children == null ? void 0 : children.length) && (children == null ? void 0 : children.map((item, itemIndex) => /* @__PURE__ */ react.createElement(react.Fragment, {
      key: `${index}-${itemIndex}`
    }, renderNode(SideNav_es_spreadProps(SideNav_es_spreadValues({}, item), {
      activeHref,
      index: itemIndex
    }))))), index === navItems.length - 1 && /* @__PURE__ */ react.createElement(SideNav_es_Divider, null));
  }));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/UserCard/UserCard.es.js




const UserCard_es_Wrapper = styled_es/* styled.div */.z.div`
  display: flex;
`;
const Info = styled_es/* styled.div */.z.div`
  margin-left: 0.5rem;
`;
const Fullname = styled_es/* styled.h5 */.z.h5`
  font-size: 1rem;
`;
const Title = styled_es/* styled.h6 */.z.h6`
  margin-bottom: 0;
  font-weight: 400;
  font-size: 0.8rem;
`;
const UserCard = ({
  name,
  picture
}) => /* @__PURE__ */ react.createElement(UserCard_es_Wrapper, null, /* @__PURE__ */ react.createElement("div", null, picture ? /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
  src: picture,
  height: 44,
  width: 44
}) : /* @__PURE__ */ react.createElement(SvgIcon_es/* SvgIcon */.l, {
  name: "account",
  size: 32
})), /* @__PURE__ */ react.createElement(Info, null, /* @__PURE__ */ react.createElement(Title, null, (0,i18n_es.t)("T\xE0i kho\u1EA3n c\u1EE7a")), /* @__PURE__ */ react.createElement(Fullname, null, name)));



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/MiniSlides/MiniSlides.es.js
var MiniSlides_es = __webpack_require__(804393);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductCoupon/ProductCoupon.es.js




var ProductCoupon_es_defProp = Object.defineProperty;
var ProductCoupon_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var ProductCoupon_es_hasOwnProp = Object.prototype.hasOwnProperty;
var ProductCoupon_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var ProductCoupon_es_defNormalProp = (obj, key, value) => key in obj ? ProductCoupon_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var ProductCoupon_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (ProductCoupon_es_hasOwnProp.call(b, prop))
      ProductCoupon_es_defNormalProp(a, prop, b[prop]);
  if (ProductCoupon_es_getOwnPropSymbols)
    for (var prop of ProductCoupon_es_getOwnPropSymbols(b)) {
      if (ProductCoupon_es_propIsEnum.call(b, prop))
        ProductCoupon_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const StyledProductCoupon = styled_es/* styled.div */.z.div`
  display: flex;
  justify-content: space-between;
`;
const CouponCode = styled_es/* styled.div */.z.div``;
const CouponDiscount = styled_es/* styled.div */.z.div((props) => `
    display: flex;
    flex-direction: ${props.reverse ? "column-reverse" : "column"};
    text-align: right;
    margin-left: 0.5rem;
  `);
const Text = styled_es/* styled.div */.z.div`
  font-size: 11px;
`;
const Highlight = styled_es/* styled.div */.z.div(({ theme }) => `
  font-size: 0.9rem;
  font-weight: 500;
  color: ${theme == null ? void 0 : theme.colors.red}
  `);
const ProductCoupon = ({
  tag,
  detail,
  className
}) => /* @__PURE__ */ react.createElement(StyledProductCoupon, {
  className
}, /* @__PURE__ */ react.createElement(CouponCode, null, /* @__PURE__ */ react.createElement(Text, null, (0,i18n_es.t)("Nh\u1EADp m\xE3")), /* @__PURE__ */ react.createElement(Tag_es/* Tag */.V, ProductCoupon_es_spreadValues({}, tag))), /* @__PURE__ */ react.createElement(CouponDiscount, {
  reverse: detail.reverse
}, /* @__PURE__ */ react.createElement(Text, null, detail.text), /* @__PURE__ */ react.createElement(Highlight, null, detail.highlight)));



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductDiscount/ProductDiscount.es.js




var ProductDiscount_es_defProp = Object.defineProperty;
var ProductDiscount_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var ProductDiscount_es_hasOwnProp = Object.prototype.hasOwnProperty;
var ProductDiscount_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var ProductDiscount_es_defNormalProp = (obj, key, value) => key in obj ? ProductDiscount_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var ProductDiscount_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (ProductDiscount_es_hasOwnProp.call(b, prop))
      ProductDiscount_es_defNormalProp(a, prop, b[prop]);
  if (ProductDiscount_es_getOwnPropSymbols)
    for (var prop of ProductDiscount_es_getOwnPropSymbols(b)) {
      if (ProductDiscount_es_propIsEnum.call(b, prop))
        ProductDiscount_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var ProductDiscount_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (ProductDiscount_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && ProductDiscount_es_getOwnPropSymbols)
    for (var prop of ProductDiscount_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && ProductDiscount_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Price = styled_es/* styled.div */.z.div`
  text-align: right;
  margin-left: 0.5rem;
`;
const ProductDiscount_es_Text = styled_es/* styled.div */.z.div`
  font-size: 11px;
`;
const ProductDiscount_es_Highlight = styled_es/* styled.div */.z.div(({ theme }) => `
  font-size: 0.9rem;
  font-weight: 500;
  color: ${theme == null ? void 0 : theme.colors.red}
  `);
const StyledProductDiscount = styled_es/* styled.div */.z.div`
  display: flex;
  justify-content: space-between;
`;
const ProductDiscount = (_a) => {
  var _b = _a, {
    discount,
    price
  } = _b, props = ProductDiscount_es_objRest(_b, [
    "discount",
    "price"
  ]);
  return /* @__PURE__ */ react.createElement(StyledProductDiscount, ProductDiscount_es_spreadValues({}, props), /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(ProductDiscount_es_Text, null, (0,i18n_es.t)("Gi\u1EA3m ngay")), /* @__PURE__ */ react.createElement(ProductDiscount_es_Highlight, null, discount)), /* @__PURE__ */ react.createElement(Price, null, /* @__PURE__ */ react.createElement(ProductDiscount_es_Text, null, (0,i18n_es.t)("Ch\u1EC9 c\xF2n"), " "), /* @__PURE__ */ react.createElement(ProductDiscount_es_Highlight, null, price)));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/PreLoad/PreLoad.es.js
var PreLoad_es = __webpack_require__(301286);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Currency/Currency.es.js
var Currency_es = __webpack_require__(526439);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/AppliedCoupon/assets/combined-shape.es.js
var background = "https://shopfront-cdn.tekoapis.com/static/518d97d5f0c97081.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/AppliedCoupon/AppliedCoupon.es.js





var AppliedCoupon_es_defProp = Object.defineProperty;
var AppliedCoupon_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var AppliedCoupon_es_hasOwnProp = Object.prototype.hasOwnProperty;
var AppliedCoupon_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var AppliedCoupon_es_defNormalProp = (obj, key, value) => key in obj ? AppliedCoupon_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var AppliedCoupon_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (AppliedCoupon_es_hasOwnProp.call(b, prop))
      AppliedCoupon_es_defNormalProp(a, prop, b[prop]);
  if (AppliedCoupon_es_getOwnPropSymbols)
    for (var prop of AppliedCoupon_es_getOwnPropSymbols(b)) {
      if (AppliedCoupon_es_propIsEnum.call(b, prop))
        AppliedCoupon_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var AppliedCoupon_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (AppliedCoupon_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && AppliedCoupon_es_getOwnPropSymbols)
    for (var prop of AppliedCoupon_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && AppliedCoupon_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CouponWrapper = styled_es/* styled.div */.z.div`
  display: flex;
  flex-direction: row;
  background-image: url('${background}');
  background-size: contain;
  background-repeat: no-repeat;
`;
const AppliedCoupon_es_StyledCol = (0,styled_es/* styled */.z)(Col_es/* Col */.J)`
  margin-top: 10px;
  padding: 0px;
  text-align: right;
  color: #ef2741;
  font-weight: 500;
  span {
    margin-right: -6px;
  }
`;
const AppliedCoupon_es_StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)`
  padding-left: 0px;
`;
const CloseButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)`
  padding-right: 0px;
  padding-top: 8px;
  padding-left: 6px;
`;
const AppliedCoupon = (_a) => {
  var _b = _a, {
    text,
    discount,
    type,
    action,
    isCloseHidden = false
  } = _b, props = AppliedCoupon_es_objRest(_b, [
    "text",
    "discount",
    "type",
    "action",
    "isCloseHidden"
  ]);
  const onRemoveClicked = () => {
    if (action)
      action();
  };
  return /* @__PURE__ */ react.createElement(CouponWrapper, AppliedCoupon_es_spreadValues({}, props), /* @__PURE__ */ react.createElement(Col_es/* Col */.J, {
    col: 6
  }, /* @__PURE__ */ react.createElement(AppliedCoupon_es_StyledButton, {
    link: true,
    disabled: true,
    icon: {
      name: type == "coupon" ? "percentage" : "tag",
      size: 25
    }
  }, text)), /* @__PURE__ */ react.createElement(Col_es/* Col */.J, {
    col: 6
  }, /* @__PURE__ */ react.createElement(Row_es/* Row */.X, null, /* @__PURE__ */ react.createElement(AppliedCoupon_es_StyledCol, {
    col: 8
  }, "-", /* @__PURE__ */ react.createElement(Currency_es/* Currency */.F, {
    value: discount
  })), !isCloseHidden && /* @__PURE__ */ react.createElement(Col_es/* Col */.J, AppliedCoupon_es_spreadValues({
    col: 4
  }, (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName: "couponSection",
    contentName: "removeCoupon"
  })), /* @__PURE__ */ react.createElement(CloseButton, {
    link: true,
    icon: { name: "circle-close", size: 20, color: "#e0e0e0" },
    onClick: onRemoveClicked
  })))));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/HorizontalSelect/HorizontalSelect.es.js
var HorizontalSelect_es = __webpack_require__(550635);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Checkbox/Checkbox.es.js
var Checkbox_es = __webpack_require__(441682);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/SelectionGroup/SelectionGroup.es.js




const GroupTitle = styled_es/* styled.p */.z.p`
  font-size: 0.8125rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #434657;
  line-height: 1.125rem;
`;
const SelectionGroup_es_Text = styled_es/* styled.p */.z.p`
  font-size: 0.8125rem;
  font-weight: 400;
  color: #434657;
  margin: 0;
  margin-left: 0.5rem;
  cursor: pointer;
  line-height: 1.125rem;
  flex: 1;
`;
const Group = styled_es/* styled.div */.z.div`
  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`;
const Option = styled_es/* styled.div */.z.div`
  display: flex;
  align-items: center;
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;
const StyledCheckbox = (0,styled_es/* styled */.z)(Checkbox_es/* Checkbox */.X)`
  margin: 0;
  border-radius: 2px;
`;
const GroupDescription = styled_es/* styled.p */.z.p`
  margin: 0;
  font-size: 0.8125rem;
  color: #82869e;
  font-weight: 400;
  margin-top: -8px;
  margin-bottom: 1rem;
`;
const Alternative = styled_es/* styled.textarea */.z.textarea`
  margin-top: 0.25rem;
  width: 100%;
  border-color: #e4e5f0;
  border-radius: 0.25rem;
  padding: 0.5rem;
  resize: none;
  color: #434657;
`;
const AlternativeTitle = styled_es/* styled.span */.z.span`
  display: inline-block;
  font-size: 0.8125rem;
  line-height: 1.5rem;
  font-weight: 500;
  color: #434657;
`;
const SelectionGroup = ({
  title,
  options,
  onSelect,
  checked,
  type = "checkbox",
  alternative = false,
  description,
  onChangeReason,
  otherReason
}) => {
  const isCheckReason = () => alternative && checked.includes(options[options.length - 1].id);
  const [reason, setReason] = (0,react.useState)(otherReason);
  const handleChange = (event) => {
    const value = event.target.value;
    setReason(value);
    onChangeReason == null ? void 0 : onChangeReason(value);
  };
  const handleSelect = (id) => () => {
    onSelect(id);
  };
  return /* @__PURE__ */ react.createElement(Group, null, title && /* @__PURE__ */ react.createElement(GroupTitle, null, title), description && /* @__PURE__ */ react.createElement(GroupDescription, {
    dangerouslySetInnerHTML: { __html: description }
  }), options.map(({ text, id }) => /* @__PURE__ */ react.createElement(Option, {
    key: id
  }, /* @__PURE__ */ react.createElement(StyledCheckbox, {
    onClick: handleSelect(id),
    checked: checked.includes(id),
    circle: type === "radio",
    width: "1rem",
    height: "1rem"
  }), /* @__PURE__ */ react.createElement(SelectionGroup_es_Text, {
    onClick: handleSelect(id),
    dangerouslySetInnerHTML: { __html: text }
  }))), isCheckReason() && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(AlternativeTitle, null, (0,i18n_es.t)("Nh\u1EADp l\xFD do")), /* @__PURE__ */ react.createElement(Alternative, {
    spellCheck: false,
    placeholder: "Text...",
    rows: 3,
    onChange: handleChange,
    value: reason
  })));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/TermAndPolicyText/TermAndPolicyText.es.js




const TermAndPolicyText_es_Text = styled_es/* styled.a */.z.a`
  &,
  &:hover,
  &:focus,
  &:visited {
    color: #047fff;
    text-decoration: none;
  }
`;
const TermAndPolicyText = ({
  link = "https://help.phongvu.vn",
  text = (0,i18n_es.t)("\u0111i\u1EC1u ki\u1EC7n s\u1EED d\u1EE5ng v\xE0 ch\xEDnh s\xE1ch"),
  className
}) => {
  return /* @__PURE__ */ react.createElement(TermAndPolicyText_es_Text, {
    href: link,
    target: "_blank",
    rel: "noopener noferrer",
    className,
    onClick: (event) => {
      event.stopPropagation();
    }
  }, text);
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/PromoItem/PromoItem.es.js + 1 modules
var PromoItem_es = __webpack_require__(385630);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/PromoBlock/PromoBlock.es.js





var PromoBlockStatus = /* @__PURE__ */ ((PromoBlockStatus2) => {
  PromoBlockStatus2["SELECTED"] = "selected";
  PromoBlockStatus2["ACTIVE"] = "active";
  PromoBlockStatus2["INACTIVE"] = "inactive";
  return PromoBlockStatus2;
})(PromoBlockStatus || {});
const Container = styled_es/* styled.div */.z.div(({ hasBorderRadius, hasBorder, theme, blockBackground }) => `
    width: 100%;
    padding: 1rem 0 1rem 1rem;
    background-color: ${blockBackground ? blockBackground : "white"};
    display: flex;
    align-items: center;
    border-bottom: ${hasBorder ? `1px solid ${theme == null ? void 0 : theme.colors.border}` : "none"};
    border-radius: ${hasBorderRadius ? `8px` : "0"};
    margin-bottom: 12px;
  `);
const Left = styled_es/* styled.div */.z.div(({ theme, showRight }) => `
    border-right: ${showRight ? `1px dashed ${theme == null ? void 0 : theme.colors.border}` : `unset`};
    padding-right: 1rem;
    flex: 1;
  `);
const Description = styled_es/* styled.p */.z.p(({ theme }) => `
    margin: 0;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1rem;
    color: ${theme == null ? void 0 : theme.colors.gray130};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin-bottom: 0.75rem;
  `);
const Button = styled_es/* styled.span */.z.span(({ isActive, theme }) => `
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 1.25rem;
    color: ${isActive ? theme == null ? void 0 : theme.colors.link500 : theme == null ? void 0 : theme.colors.gray130};
    width: 6rem;
    text-align: center;
    padding: 0.5rem;

    &:hover {
      cursor: pointer;
    }
`);
const StyledPromoItem = (0,styled_es/* styled */.z)(PromoItem_es/* PromoItem */.D)`
  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;
const PromoBlock = ({
  benefits,
  description,
  status,
  hasBorder,
  hasBorderRadius = false,
  blockBackground,
  customBtn,
  onClick,
  showRight = true
}) => {
  const statusMap = {
    ["selected" /* SELECTED */]: (0,i18n_es.t)("B\u1ECF ch\u1ECDn"),
    ["active" /* ACTIVE */]: (0,i18n_es.t)("\xC1p d\u1EE5ng"),
    ["inactive" /* INACTIVE */]: (0,i18n_es.t)("Mua th\xEAm")
  };
  return /* @__PURE__ */ react.createElement(Container, {
    hasBorder,
    hasBorderRadius,
    blockBackground
  }, /* @__PURE__ */ react.createElement(Left, {
    showRight
  }, description && /* @__PURE__ */ react.createElement(Description, null, description), benefits.map(({ type, text, imgSrc }, index) => /* @__PURE__ */ react.createElement(StyledPromoItem, {
    type,
    text,
    imgSrc,
    key: index
  }))), showRight && (customBtn || /* @__PURE__ */ react.createElement(Button, {
    isActive: status !== "inactive" /* INACTIVE */,
    onClick
  }, statusMap[status] || "")));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Listing/Filter/components/ActivatedFilters.es.js
var ActivatedFilters_es = __webpack_require__(743405);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/ButtonChevron/ButtonChevron.es.js
var ButtonChevron_es = __webpack_require__(708966);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Listing/Filter/components/ShowMoreBtn.es.js



const ShowMoreBtn_es_Wrapper = styled_es/* styled.div */.z.div`
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 0.8px solid #e0e0e0;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  margin-top: 0.3rem;
  float: right;
`;
const ShowMoreBtn_es_StyledButton = (0,styled_es/* styled */.z)(ButtonChevron_es/* ButtonChevron */.y)`
  padding: 5px;
  margin: 0;
  position: relative;
  top: 2px;
`;
const ShowMoreBtn = ({
  setIsActive,
  isActive
}) => {
  return /* @__PURE__ */ react.createElement(ShowMoreBtn_es_Wrapper, {
    onClick: () => setIsActive(!isActive)
  }, /* @__PURE__ */ react.createElement(ShowMoreBtn_es_StyledButton, {
    link: true,
    direction: isActive ? "up" : "down"
  }));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Listing/Filter/components/FilterRow.es.js





const FilterRow_es_Title = styled_es/* styled.div */.z.div`
  font-weight: 600;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;
const StyledOption = (0,styled_es/* styled */.z)(SelectOption_es/* SelectOption */.$)((props) => `
    margin-right: 0.5rem;
    margin-bottom: 0.3rem;
    padding: 0.375rem 1.25rem;
    color: ${props.isActive ? props.theme.brand.primary : "#333"};
    cursor: pointer;
    &:hover {
      background: #f3f3f3;
    }
  `);
const StyledRow = (0,styled_es/* styled */.z)(Row_es/* Row */.X)`
  margin-bottom: 0.25rem;
  margin-left: 0;
  margin-right: 0;
  > * {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
`;
const StyledShowMoreBtn = (0,styled_es/* styled */.z)(ShowMoreBtn)`
  margin-top: 0.3rem;
  float: right;
`;
const ListOption = (0,styled_es/* styled */.z)(Col_es/* Col */.J)`
  height: ${(props) => props.isShowMore ? "auto" : "2.5rem"};
  overflow: hidden;
`;
const FilterRow = ({
  value,
  filter,
  onClickOption
}) => {
  const [isShowMore, setIsShowMore] = (0,react.useState)(false);
  const [isHideButtonShowMore, setIsHideButtonShowMore] = (0,react.useState)(false);
  const isSelected = (0,react.useCallback)((filterValue) => {
    if (!value) {
      return false;
    }
    return !!~value.split(",").indexOf(filterValue.optionCode);
  }, [value]);
  (0,react.useEffect)(() => {
    var _a;
    const height = ((_a = document.getElementById(`js-${filter.code}`)) == null ? void 0 : _a.clientHeight) || 0;
    if (height < 90) {
      setIsHideButtonShowMore(true);
    }
  }, []);
  return /* @__PURE__ */ react.createElement(StyledRow, null, /* @__PURE__ */ react.createElement(Col_es/* Col */.J, {
    col: 1.5
  }, /* @__PURE__ */ react.createElement(FilterRow_es_Title, null, filter.name)), /* @__PURE__ */ react.createElement(ListOption, {
    isShowMore,
    col: 10
  }, /* @__PURE__ */ react.createElement("div", {
    id: `js-${filter.code}`
  }, filter.options.map((option, index) => /* @__PURE__ */ react.createElement(StyledOption, {
    activeBackground: "#fff",
    isActive: isSelected(option),
    onClickOption: () => onClickOption && onClickOption(option),
    key: index,
    stickySize: "sm"
  }, option.optionName)))), /* @__PURE__ */ react.createElement(Col_es/* Col */.J, {
    col: 0.5
  }, !isHideButtonShowMore && /* @__PURE__ */ react.createElement(StyledShowMoreBtn, {
    isActive: isShowMore,
    setIsActive: setIsShowMore
  })));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Listing/Filter/components/AdvancedFilterRow.es.js





const AdvancedFilterRow_es_Title = styled_es/* styled.div */.z.div`
  font-weight: 600;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;
const AdvancedFilterRow_es_StyledRow = (0,styled_es/* styled */.z)(Row_es/* Row */.X)`
  margin-bottom: 0.25rem;
  margin-left: 0;
  margin-right: 0;
  > * {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
`;
const DropdownOption = (0,styled_es/* styled */.z)(JDDropdown_es/* JDDropdown */.F)`
  max-width: 19%;
  margin-right: 0.5rem;
`;
const AdvancedFilterRow = ({
  filters,
  onClickOption,
  activeValues = []
}) => {
  return /* @__PURE__ */ react.createElement(AdvancedFilterRow_es_StyledRow, null, /* @__PURE__ */ react.createElement(Col_es/* Col */.J, {
    col: 1.5
  }, /* @__PURE__ */ react.createElement(AdvancedFilterRow_es_Title, null, (0,i18n_es.t)("B\u1ED9 l\u1ECDc n\xE2ng cao"))), /* @__PURE__ */ react.createElement(Col_es/* Col */.J, {
    col: 10.5
  }, filters.slice(5, 10).map((filter, index) => {
    return /* @__PURE__ */ react.createElement(DropdownOption, {
      count: activeValues.filter((value) => value.filterCode === filter.code).length,
      text: filter.name,
      key: index
    }, /* @__PURE__ */ react.createElement(react.Fragment, null, filter.options.map((option, index2) => /* @__PURE__ */ react.createElement(Button_es/* Button */.z, {
      key: index2,
      link: true,
      onClick: () => {
        if (onClickOption) {
          onClickOption(option);
        }
      },
      variant: activeValues.findIndex((activatedValue) => activatedValue.optionCode === option.optionCode) !== -1 ? "primary" : "normal"
    }, option.optionName))));
  })));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Listing/Filter/Filter.es.js







const ListFilters = styled_es/* styled.div */.z.div`
  padding: 1rem;
`;
const StyledCard = (0,styled_es/* styled */.z)(Card_es/* Card */.Z)`
  width: 100%;
  overflow: unset;
`;
const Filter = ({
  filters,
  onClickOption,
  query,
  activeFilters = [],
  clearFilterLink
}) => /* @__PURE__ */ react.createElement(StyledCard, null, /* @__PURE__ */ react.createElement(BlockHeader_es/* BlockHeader */.t, {
  content: /* @__PURE__ */ react.createElement(ActivatedFilters_es/* ActivatedFilters */.x, {
    onClick: onClickOption,
    activeValues: activeFilters
  }),
  title: (0,i18n_es.t)("B\u1ED9 l\u1ECDc"),
  actionLink: activeFilters.length && {
    href: clearFilterLink || "#",
    title: (0,i18n_es.t)("X\xF3a b\u1ED9 l\u1ECDc"),
    color: "#ef2741",
    hideIcon: true,
    regionName: "headerFilter",
    contentName: "resetFilter"
  } || void 0
}), /* @__PURE__ */ react.createElement(ListFilters, null, filters.slice(0, 5).map((filter, index) => {
  const value = () => {
    var _a;
    return query[filter.code] || ((_a = query.dynamicFields) == null ? void 0 : _a[filter.code]);
  };
  return /* @__PURE__ */ react.createElement(FilterRow, {
    value: value(),
    onClickOption,
    key: index,
    filter
  });
}), filters.length > 5 && /* @__PURE__ */ react.createElement(AdvancedFilterRow, {
  activeValues: activeFilters,
  onClickOption,
  filters
})));



// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var router = __webpack_require__(35304);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Listing/Filter/components/SortBar.es.js








var SortBar_es_defProp = Object.defineProperty;
var SortBar_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var SortBar_es_hasOwnProp = Object.prototype.hasOwnProperty;
var SortBar_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var SortBar_es_defNormalProp = (obj, key, value) => key in obj ? SortBar_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var SortBar_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (SortBar_es_hasOwnProp.call(b, prop))
      SortBar_es_defNormalProp(a, prop, b[prop]);
  if (SortBar_es_getOwnPropSymbols)
    for (var prop of SortBar_es_getOwnPropSymbols(b)) {
      if (SortBar_es_propIsEnum.call(b, prop))
        SortBar_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SortBar_es_StyledOption = (0,styled_es/* styled */.z)(SelectOption_es/* SelectOption */.$)((props) => `
  margin-right: 1rem;
  cursor: pointer;
  color: ${props.isActive ? props.theme.brand.primary : ""};
  background-color: ${props.isActive ? props.theme.brand.tertiary : ""};
  padding: 0.5rem;
  &:hover {
    background: ${props.isActive ? "" : "#f3f3f3"};
  }
`);
const OptionName = styled_es/* styled.span */.z.span`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;
const SortBar_es_Wrapper = styled_es/* styled.div */.z.div`
  background: #fff;
  width: 100%;
  border-bottom: 1px solid #eaeaea;
  font-size: 14px;
  height: 64px;
  display: flex;
  justify-content: space-between;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;
const FlexCenter = styled_es/* styled.div */.z.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
`;
const SortBar_es_Title = styled_es/* styled.div */.z.div`
  margin-right: 2rem;
  font-weight: 600;
`;
const Flag = styled_es/* styled.div */.z.div`
  position: absolute;
  top: -72px;
`;
const SortBar = ({
  className,
  onClickOption
}) => {
  const currentQuery = (0,router.useRouter)().query;
  (0,react.useEffect)(() => {
    var _a;
    if (typeof window !== "undefined" && currentQuery.page) {
      (_a = document.getElementById("js-sort-bar")) == null ? void 0 : _a.scrollIntoView();
    }
  }, [currentQuery.page]);
  return /* @__PURE__ */ react.createElement(SortBar_es_Wrapper, {
    className
  }, /* @__PURE__ */ react.createElement(Flag, {
    id: "js-sort-bar"
  }), /* @__PURE__ */ react.createElement(FlexCenter, null, /* @__PURE__ */ react.createElement(SortBar_es_Title, null, (0,i18n_es.t)("S\u1EAFp x\u1EBFp theo")), /* @__PURE__ */ react.createElement(SortBar_es_StyledOption, SortBar_es_spreadValues({
    stickySize: "sm",
    isActive: currentQuery.sort === "SORT_BY_DISCOUNT_PERCENT",
    onClickOption: () => onClickOption && onClickOption("SORT_BY_DISCOUNT_PERCENT", types_es/* OrderBy.DESC */.d.DESC)
  }, (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName: "sortFilterProduct",
    contentName: "sort=discount&order=DESC",
    target: "searchProductResult",
    payload: JSON.stringify({
      screenName: "searchProductResult"
    })
  })), /* @__PURE__ */ react.createElement(OptionName, null, (0,i18n_es.t)("Khuy\u1EBFn m\xE3i t\u1ED1t nh\u1EA5t"))), /* @__PURE__ */ react.createElement(SortBar_es_StyledOption, SortBar_es_spreadValues({
    stickySize: "sm",
    activeBackground: "rgba(20, 53, 195, 0.08)",
    isActive: currentQuery.sort === "SORT_BY_TOP_SALE_QUANTITY_90_DAYS",
    onClickOption: () => onClickOption && onClickOption("SORT_BY_TOP_SALE_QUANTITY_90_DAYS", types_es/* OrderBy.DESC */.d.DESC)
  }, (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName: "sortFilterProduct",
    contentName: "sort=quantity.last_3_month&order=DESC",
    target: "searchProductResult",
    payload: JSON.stringify({
      screenName: "searchProductResult"
    })
  })), /* @__PURE__ */ react.createElement(OptionName, null, (0,i18n_es.t)("B\xE1n ch\u1EA1y"))), /* @__PURE__ */ react.createElement(SortBar_es_StyledOption, SortBar_es_spreadValues({
    stickySize: "sm",
    activeBackground: "rgba(20, 53, 195, 0.08)",
    isActive: currentQuery.sort === "SORT_BY_PUBLISH_AT",
    onClickOption: () => onClickOption && onClickOption("SORT_BY_PUBLISH_AT", types_es/* OrderBy.DESC */.d.DESC)
  }, (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName: "sortFilterProduct",
    contentName: "sort=new&order=DESC",
    target: "searchProductResult",
    payload: JSON.stringify({
      screenName: "searchProductResult"
    })
  })), /* @__PURE__ */ react.createElement(OptionName, null, (0,i18n_es.t)("M\u1EDBi v\u1EC1"))), /* @__PURE__ */ react.createElement(SortBar_es_StyledOption, SortBar_es_spreadValues({
    stickySize: "sm",
    activeBackground: "rgba(20, 53, 195, 0.08)",
    isActive: currentQuery.sort === "SORT_BY_PRICE" && currentQuery.order === types_es/* OrderBy.DESC */.d.DESC,
    onClickOption: () => onClickOption && onClickOption("SORT_BY_PRICE", types_es/* OrderBy.DESC */.d.DESC)
  }, (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName: "sortFilterProduct",
    contentName: "sort=bestPrice&order=DESC",
    target: "searchProductResult",
    payload: JSON.stringify({
      screenName: "searchProductResult"
    })
  })), /* @__PURE__ */ react.createElement(OptionName, null, (0,i18n_es.t)("Gi\xE1 gi\u1EA3m d\u1EA7n"))), /* @__PURE__ */ react.createElement(SortBar_es_StyledOption, SortBar_es_spreadValues({
    stickySize: "sm",
    activeBackground: "rgba(20, 53, 195, 0.08)",
    isActive: currentQuery.sort === "SORT_BY_PRICE" && currentQuery.order === types_es/* OrderBy.ASC */.d.ASC,
    onClickOption: () => onClickOption && onClickOption("SORT_BY_PRICE", types_es/* OrderBy.ASC */.d.ASC)
  }, (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName: "sortFilterProduct",
    contentName: "sort=bestPrice&order=ASC",
    target: "searchProductResult",
    payload: JSON.stringify({
      screenName: "searchProductResult"
    })
  })), /* @__PURE__ */ react.createElement(OptionName, null, (0,i18n_es.t)("Gi\xE1 t\u0103ng d\u1EA7n")))));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Listing/Filter/components/PriceInput.es.js
var PriceInput_es = __webpack_require__(872861);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Overlay/Overlay.es.js
var Overlay_es = __webpack_require__(55257);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/organisms/Gallery/Gallery.es.js
var Gallery_es = __webpack_require__(547425);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/ProductImages/SmallImage/SmallImage.es.js



var SmallImage_es_defProp = Object.defineProperty;
var SmallImage_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var SmallImage_es_hasOwnProp = Object.prototype.hasOwnProperty;
var SmallImage_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var SmallImage_es_defNormalProp = (obj, key, value) => key in obj ? SmallImage_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var SmallImage_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (SmallImage_es_hasOwnProp.call(b, prop))
      SmallImage_es_defNormalProp(a, prop, b[prop]);
  if (SmallImage_es_getOwnPropSymbols)
    for (var prop of SmallImage_es_getOwnPropSymbols(b)) {
      if (SmallImage_es_propIsEnum.call(b, prop))
        SmallImage_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SmallImage_es_ImageWrapper = styled_es/* styled.button */.z.button((props) => `
  border-radius: 4px;
  position: relative;
  border: 1px solid ${props.active ? props.theme.brand.primary : "transparent"};
  width: 50px;
  margin-right: .5rem;
  padding: .2rem;
  background-color: transparent;
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
  `);
const Image = styled_es/* styled.img */.z.img`
  object-fit: contain;
  width: 100%;
  height: calc(100% - 10px);
`;
const Extra = styled_es/* styled.div */.z.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
const SmallImage = ({
  image,
  active,
  onMouseEnter,
  onClick,
  extra
}) => {
  return /* @__PURE__ */ react.createElement(SmallImage_es_ImageWrapper, {
    active,
    onMouseEnter,
    onClick
  }, /* @__PURE__ */ react.createElement(Image, SmallImage_es_spreadValues({}, image)), extra && /* @__PURE__ */ react.createElement(Extra, null, extra));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/ProductImages/ProductImages.es.js





var ProductImages_es_defProp = Object.defineProperty;
var ProductImages_es_defProps = Object.defineProperties;
var ProductImages_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var ProductImages_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var ProductImages_es_hasOwnProp = Object.prototype.hasOwnProperty;
var ProductImages_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var ProductImages_es_defNormalProp = (obj, key, value) => key in obj ? ProductImages_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var ProductImages_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (ProductImages_es_hasOwnProp.call(b, prop))
      ProductImages_es_defNormalProp(a, prop, b[prop]);
  if (ProductImages_es_getOwnPropSymbols)
    for (var prop of ProductImages_es_getOwnPropSymbols(b)) {
      if (ProductImages_es_propIsEnum.call(b, prop))
        ProductImages_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var ProductImages_es_spreadProps = (a, b) => ProductImages_es_defProps(a, ProductImages_es_getOwnPropDescs(b));
const Images = styled_es/* styled.div */.z.div`
  display: flex;
  flex-direction: row;
  height: 50px;
`;
const ProductImages_es_Wrapper = styled_es/* styled.div */.z.div`
  background-color: #fff;
`;
const ActiveImageWrapper = styled_es/* styled.div */.z.div`
  margin-bottom: 0.5rem;
  position: relative;
`;
const ProductImages_es_FrameWrapper = styled_es/* styled.div */.z.div(({ frame }) => `
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  background-image: url(${frame});
  background-size: cover;
  height: 100%;
  width: 100%;
  cursor: pointer;
  `);
const ProductImages = ({
  images,
  frame,
  sku,
  galleryBgColor
}) => {
  const [activeIndex, setActiveIndex] = (0,react.useState)(0);
  const [activeIndexSlide, setActiveIndexSlide] = (0,react.useState)(0);
  const activeImage = (0,react.useMemo)(() => images[activeIndex], [activeIndex, images]);
  const maxFourImages = (0,react.useMemo)(() => images.slice(0, 6), [images]);
  const [galleryVisible, setGalleryVisible] = (0,react.useState)(false);
  const toggleGallery = (0,react.useCallback)(() => {
    setGalleryVisible(!galleryVisible);
  }, [galleryVisible]);
  return /* @__PURE__ */ react.createElement(ProductImages_es_Wrapper, ProductImages_es_spreadValues({}, (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName: "imgProductDetail",
    contentName: "viewImage",
    target: "productImage",
    payload: JSON.stringify({
      sku,
      screenName: "productDetail",
      index: activeIndex
    })
  })), /* @__PURE__ */ react.createElement(ActiveImageWrapper, {
    onClick: () => activeImage && toggleGallery()
  }, frame && /* @__PURE__ */ react.createElement(ProductImages_es_FrameWrapper, {
    frame
  }), /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, ProductImages_es_spreadProps(ProductImages_es_spreadValues({}, activeImage), {
    onClick: () => activeImage && toggleGallery(),
    className: "productDetailPreview",
    borderRadius: 8,
    imageWidth: 500,
    contain: true
  }))), /* @__PURE__ */ react.createElement(Images, null, maxFourImages.map((image, index) => /* @__PURE__ */ react.createElement(SmallImage, {
    key: index,
    active: index === activeIndex,
    image,
    onMouseEnter: () => {
      !(index === 5 && images.length > 6) && setActiveIndex(index);
      setActiveIndexSlide(index);
    },
    onClick: () => {
      toggleGallery();
    },
    extra: index === 5 && images.length > 6 ? `+${images.length - 6}` : void 0
  }))), /* @__PURE__ */ react.createElement(Overlay_es/* Overlay */.a, {
    show: galleryVisible,
    onEscPressed: toggleGallery
  }, /* @__PURE__ */ react.createElement(Gallery_es/* Gallery */.r, {
    onClose: toggleGallery,
    images: images.map((image) => ({
      imageUrl: image.src,
      caption: "",
      subCaption: "",
      thumbnailUrl: image.src
    })),
    activeImageIndex: activeIndexSlide,
    bgColor: galleryBgColor
  })));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/ProductInfo/DetailGifts/DetailGifts.es.js
var DetailGifts_es = __webpack_require__(903677);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/ProductInfo/ProductVariants/ProductVariant/ProductVariant.es.js



const ProductVariant_es_Wrapper = styled_es/* styled.div */.z.div((props) => `
    width: ${props.type === "image" ? "44px" : "fit-content"};
    height: ${props.type === "image" ? "44px" : "fit-content"};
    border: 1px ${props.isActive ? props.theme.brand.primary : "#e0e0e0"} solid;
    position: relative;
    border-radius: 4px;

    margin: 0 8px 8px 0;
    ${props.type !== "image" && "padding: 8px 16px;"}
    color: ${props.isActive ? props.theme.brand.primary : "black"};
    background-color: ${props.isVisible || props.isActive === true ? "#fff" : "#e0e0e0"};

    text-transform: capitalize;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;


    cursor: ${props.isVisible || props.isActive === true ? "pointer" : "not-allowed"};
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 4px;
    }
`);
const Value = styled_es/* styled.span */.z.span``;
const ProductVariant = ({
  option,
  type,
  index,
  onSelectVariant
}) => {
  return /* @__PURE__ */ react.createElement(ProductVariant_es_Wrapper, {
    isActive: option.selected,
    isVisible: option.visible,
    type,
    onClick: () => onSelectVariant(option, index)
  }, type === "image" && option.image ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
    src: option.image.src,
    alt: option.image.alt
  })) : /* @__PURE__ */ react.createElement(Value, null, option.value));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/ProductInfo/ProductVariants/ProductVariants.es.js




const ProductVariants_es_Wrapper = styled_es/* styled.div */.z.div`
  display: flex;
`;
const VariantWrapper = styled_es/* styled.div */.z.div`
  margin-left: 8px;
  display: flex;
  flex-flow: wrap;
  max-width: calc(100% - 64px);
`;
const SelectedVariant = styled_es/* styled.div */.z.div`
  font-size: 0/75rem;
  color: #848788;
  margin-top: 8px;
  text-transform: capitalize;
`;
const ProductVariants = ({
  configuration,
  onSelectVariant,
  index,
  className
}) => {
  return /* @__PURE__ */ react.createElement(ProductVariants_es_Wrapper, {
    className
  }, /* @__PURE__ */ react.createElement(SelectedVariant, null, configuration.name), /* @__PURE__ */ react.createElement(VariantWrapper, null, configuration.options.map((variant) => /* @__PURE__ */ react.createElement(ProductVariant, {
    key: variant.optionId,
    option: variant,
    onSelectVariant,
    type: configuration.optionType,
    index
  }))));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/ProductInfo/DiscountPromotion/DiscountPromotion.es.js
var DiscountPromotion_es = __webpack_require__(323442);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/ProductInfo/DefaultPromotions/DefaultPromotions.es.js
var DefaultPromotions_es = __webpack_require__(406834);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/helpers/index.es.js
var index_es = __webpack_require__(525369);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/ProductShortDescription/ProductShortDescription.es.js






var ProductShortDescription_es_defProp = Object.defineProperty;
var ProductShortDescription_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var ProductShortDescription_es_hasOwnProp = Object.prototype.hasOwnProperty;
var ProductShortDescription_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var ProductShortDescription_es_defNormalProp = (obj, key, value) => key in obj ? ProductShortDescription_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var ProductShortDescription_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (ProductShortDescription_es_hasOwnProp.call(b, prop))
      ProductShortDescription_es_defNormalProp(a, prop, b[prop]);
  if (ProductShortDescription_es_getOwnPropSymbols)
    for (var prop of ProductShortDescription_es_getOwnPropSymbols(b)) {
      if (ProductShortDescription_es_propIsEnum.call(b, prop))
        ProductShortDescription_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Content = styled_es/* styled.div */.z.div(({ maxHeight, expanded }) => `
  background-color: #fff;
  max-height: ${maxHeight};
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  ${expanded ? "" : `
  &:after {
    content: ' ';
    background: linear-gradient(transparent, hsla(0, 0%, 100%, 0) 70%, #fff 90%);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
    position: absolute;
    bottom: 0;
    height: 40px;
    width: 100%;
  }
  `}
`);
const ProductShortDescription_es_Wrapper = styled_es/* styled.div */.z.div`
  position: relative;
`;
const ShowMoreWrapper = styled_es/* styled.div */.z.div``;
const StyledButtonChevron = (0,styled_es/* styled */.z)(ButtonChevron_es/* ButtonChevron */.y)(({ theme }) => `
  border-radius: 0;
  justify-content: center;
  padding: 24px 0;
  color: ${theme == null ? void 0 : theme.brand.primary};
  width: calc(100% - 32px);
  margin-left: 16px;
  &:hover {
    color: ${theme == null ? void 0 : theme.brand.primary}
  }
  span {
    margin-left: 4px;
  }
`);
const HEADER_HEIGHT = 72;
const HEADING_HEIGHT = 56;
const ProductShortDescription = ({
  children,
  maxHeight,
  expandLabel,
  collapseLabel,
  moveTop = true,
  className,
  detailArticleScrollHeight
}) => {
  const [showMoreNeeded, setShowMoreNeeded] = (0,react.useState)(false);
  const [expanded, setExpanded] = (0,react.useState)(false);
  const descriptionRef = (0,react.useRef)(null);
  const descriptionCallbackRef = (node) => {
    if (node && !showMoreNeeded) {
      descriptionRef.current = node;
      setShowMoreNeeded(node.clientHeight < (detailArticleScrollHeight || 0));
    }
  };
  const handleClick = () => {
    setExpanded((prev) => {
      if (prev && moveTop && descriptionRef && descriptionRef.current) {
        const element = descriptionRef.current;
        window.scrollTo({
          left: 0,
          top: (0,index_es/* getElementOffset */.pW)(element).top - HEADER_HEIGHT - HEADING_HEIGHT
        });
      }
      return !prev;
    });
  };
  expandLabel = expandLabel || (0,i18n_es.t)("Xem th\xEAm");
  collapseLabel = collapseLabel || (0,i18n_es.t)("Thu g\u1ECDn");
  return /* @__PURE__ */ react.createElement(ProductShortDescription_es_Wrapper, {
    className
  }, /* @__PURE__ */ react.createElement(Content, {
    ref: descriptionCallbackRef,
    maxHeight: expanded ? "fit-content" : `${maxHeight}px`,
    expanded
  }, children), showMoreNeeded && /* @__PURE__ */ react.createElement(ShowMoreWrapper, ProductShortDescription_es_spreadValues({}, (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName: "descriptionDetail",
    contentName: "viewMore"
  })), /* @__PURE__ */ react.createElement(StyledButtonChevron, {
    block: true,
    link: true,
    direction: expanded ? "up" : "down",
    onClick: handleClick
  }, expanded ? collapseLabel : expandLabel)));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/organisms/Swiper/Swiper.es.js
var Swiper_es = __webpack_require__(732553);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/ProductCombos/ProductCombo/ProductCombo.es.js





var ProductCombo_es_defProp = Object.defineProperty;
var ProductCombo_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var ProductCombo_es_hasOwnProp = Object.prototype.hasOwnProperty;
var ProductCombo_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var ProductCombo_es_defNormalProp = (obj, key, value) => key in obj ? ProductCombo_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var ProductCombo_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (ProductCombo_es_hasOwnProp.call(b, prop))
      ProductCombo_es_defNormalProp(a, prop, b[prop]);
  if (ProductCombo_es_getOwnPropSymbols)
    for (var prop of ProductCombo_es_getOwnPropSymbols(b)) {
      if (ProductCombo_es_propIsEnum.call(b, prop))
        ProductCombo_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var ProductCombo_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (ProductCombo_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && ProductCombo_es_getOwnPropSymbols)
    for (var prop of ProductCombo_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && ProductCombo_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCombo_es_Wrapper = styled_es/* styled.div */.z.div`
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  padding: 16px;
`;
const ProductCombo_es_Images = styled_es/* styled.div */.z.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
const ProductCombo_es_Image = styled_es/* styled.div */.z.div`
  width: 60px;
  height: 60px;
`;
const Overlay = (0,styled_es/* styled */.z)(ProductCombo_es_Image)`
  border-radius: 4px;
  color: #b4b4b4;
  background-color: #f6f6f6;

  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const ProductCombo_es_Text = styled_es/* styled.div */.z.div`
  font-size: 0.625rem;
`;
const Retangle = styled_es/* styled.div */.z.div`
  margin: 16px auto;
  position: relative;
  display: block;
  text-align: center;

  &::before {
    content: '';
    top: 10px;
    left: 0;
    width: 100%;
    height: 1px;

    border-radius: 2px;
    background-color: #d6dde4;
    display: inline-block;
    position: absolute;
  }

  span {
    color: #848788;
    background-color: #fff;
    padding: 0 10px;
    font-size: 10px;
    line-height: 1.6;
    text-transform: uppercase;

    position: relative;
    display: inline-block;
    border: solid 1px #e0e0e0;
  }
`;
const PriceInfo = styled_es/* styled.div */.z.div`
  margin-bottom: 4px;
  display: flex;
  flex-direction: column;
`;
const ProductCombo_es_PriceWrapper = styled_es/* styled.div */.z.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const SavePrice = styled_es/* styled.span */.z.span`
  margin-left: 4px;
  span {
    color: #eb2101;
    font-weight: bold;
  }
`;
const Footer = styled_es/* styled.div */.z.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const ViewDetail = styled_es/* styled.a */.z.a`
  color: #047fff;
  cursor: pointer;
  text-decoration: none;
`;
const IconWrapper = styled_es/* styled.div */.z.div`
  width: 16px;
  height: 16px;
`;
const StyledConcurrency = (0,styled_es/* styled */.z)(Currency_es/* Currency */.F)`
  margin-left: 4px;
`;
const ProductCombo_es_ImageWrapper = styled_es/* styled.div */.z.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
const StyledProductPrice = (0,styled_es/* styled */.z)(ProductPrice_es/* ProductPrice */.j)`
  margin-left: 4px;
`;
const ProductCombo = (_a) => {
  var _b = _a, {
    productCombo,
    className,
    linkDetail = "",
    linkBuy = ""
  } = _b, props = ProductCombo_es_objRest(_b, [
    "productCombo",
    "className",
    "linkDetail",
    "linkBuy"
  ]);
  return /* @__PURE__ */ react.createElement(ProductCombo_es_Wrapper, ProductCombo_es_spreadValues({
    className
  }, props), /* @__PURE__ */ react.createElement(ProductCombo_es_Images, null, productCombo.images.slice(0, 3).map((image, index) => {
    if (productCombo.bundleProduct && productCombo.bundleProduct.length > 3) {
      if (index == 2) {
        return /* @__PURE__ */ react.createElement(Overlay, {
          key: index
        }, /* @__PURE__ */ react.createElement("div", null, productCombo.bundleProduct.length - 2, " "), /* @__PURE__ */ react.createElement(ProductCombo_es_Text, null, (0,i18n_es.t)("s\u1EA3n ph\u1EA9m")));
      }
    }
    return /* @__PURE__ */ react.createElement(ProductCombo_es_ImageWrapper, {
      key: index
    }, /* @__PURE__ */ react.createElement(ProductCombo_es_Image, null, /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
      contain: true,
      src: image.src,
      width: 60,
      height: 60
    })), index !== productCombo.images.length - 1 && /* @__PURE__ */ react.createElement(SvgIcon_es/* SvgIcon */.l, {
      name: "plus-default",
      size: 16,
      color: "#848788"
    }));
  })), /* @__PURE__ */ react.createElement(Retangle, null, /* @__PURE__ */ react.createElement("span", null, (0,i18n_es.t)("Ch\u1EC9 c\xF2n"))), /* @__PURE__ */ react.createElement(PriceInfo, null, productCombo.price.price && /* @__PURE__ */ react.createElement(ProductCombo_es_PriceWrapper, null, /* @__PURE__ */ react.createElement(IconWrapper, null, /* @__PURE__ */ react.createElement(SvgIcon_es/* SvgIcon */.l, {
    name: "cash-outline",
    size: 16,
    color: "green"
  })), /* @__PURE__ */ react.createElement(StyledProductPrice, {
    price: productCombo.price.price,
    listedPrice: productCombo.price.listedPrice,
    horizontal: true
  })), productCombo.price.listedPrice && /* @__PURE__ */ react.createElement(ProductCombo_es_PriceWrapper, null, /* @__PURE__ */ react.createElement(IconWrapper, null, /* @__PURE__ */ react.createElement(SvgIcon_es/* SvgIcon */.l, {
    name: "promotion-fill",
    size: 16,
    color: "red"
  })), /* @__PURE__ */ react.createElement(SavePrice, null, (0,i18n_es.t)("Ti\u1EBFt ki\u1EC7m:"), /* @__PURE__ */ react.createElement(StyledConcurrency, {
    value: productCombo.price.listedPrice - productCombo.price.price
  })))), /* @__PURE__ */ react.createElement(Footer, null, /* @__PURE__ */ react.createElement(ViewDetail, {
    href: linkDetail
  }, (0,i18n_es.t)("Xem chi ti\u1EBFt")), /* @__PURE__ */ react.createElement(Button_es/* Button */.z, {
    variant: "primary",
    outline: true,
    link: true,
    href: linkBuy
  }, "Mua ngay")));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/ProductCombos/ProductCombos.es.js





const StyledSwiper = (0,styled_es/* styled */.z)(Swiper_es/* Swiper */.t)`
  .swiper-wrapper {
  }
`;
const ProductCombos = ({
  products,
  name,
  className
}) => {
  return /* @__PURE__ */ react.createElement(Card_es/* Card */.Z, {
    header: /* @__PURE__ */ react.createElement(BlockHeader_es/* BlockHeader */.t, {
      title: (0,i18n_es.t)("Ti\u1EBFt ki\u1EC7m h\u01A1n khi mua c\xF9ng {{name}}", { name })
    }),
    className
  }, /* @__PURE__ */ react.createElement(StyledSwiper, {
    observer: true,
    observeParents: true,
    hasNavigation: true,
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 16
  }, products.map((product) => {
    return /* @__PURE__ */ react.createElement(ProductCombo, {
      productCombo: product,
      key: product.sku,
      linkDetail: product.linkDetail,
      linkBuy: product.linkBuy
    });
  })));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/Promotion/Promotion.es.js
var Promotion_es = __webpack_require__(469381);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/Promotion/PromotionInfo/PromotionInfo.es.js
var PromotionInfo_es = __webpack_require__(468382);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/MobileLink/MobileLink.es.js
var MobileLink_es = __webpack_require__(300560);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/SellerCard.es.js





var SellerCard_es_defProp = Object.defineProperty;
var SellerCard_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var SellerCard_es_hasOwnProp = Object.prototype.hasOwnProperty;
var SellerCard_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var SellerCard_es_defNormalProp = (obj, key, value) => key in obj ? SellerCard_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var SellerCard_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (SellerCard_es_hasOwnProp.call(b, prop))
      SellerCard_es_defNormalProp(a, prop, b[prop]);
  if (SellerCard_es_getOwnPropSymbols)
    for (var prop of SellerCard_es_getOwnPropSymbols(b)) {
      if (SellerCard_es_propIsEnum.call(b, prop))
        SellerCard_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var SellerCard_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (SellerCard_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && SellerCard_es_getOwnPropSymbols)
    for (var prop of SellerCard_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && SellerCard_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const mapAvatarSize = {
  sm: 26,
  md: 42,
  lg: 58
};
const SellerName = styled_es/* styled.div */.z.div`
  font-size: 15px;
  line-height: 24px;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    color: #0d80d0;
  }
`;
const Slogan = styled_es/* styled.div */.z.div`
  font-size: 12px;
  line-height: 16px;
  color: #82869e;
`;
const StyledTick = styled_es/* styled.div */.z.div`
  position: relative;
  display: inline-block;
  width: 14px;
  height: 14px;
  background-color: #52c401;
  margin-left: 4px;
  margin-top: 4px;
  border-radius: 50%;
  &:after {
    position: absolute;
    display: table;
    border: 1px solid #fff;
    border-top: 0;
    border-left: 0;
    transform: rotate(45deg) scale(1) translate(-50%, -50%);
    transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
    content: ' ';
    top: 50%;
    left: 25%;
    width: 4px;
    height: 7px;
    margin-left: 0.5px;
  }
`;
const SellerCard = (_a) => {
  var _b = _a, {
    avatar,
    name,
    slogan,
    showSlogan = true,
    showTick = true,
    avatarSize = "md",
    link,
    isAvatarHidden = false
  } = _b, props = SellerCard_es_objRest(_b, [
    "avatar",
    "name",
    "slogan",
    "showSlogan",
    "showTick",
    "avatarSize",
    "link",
    "isAvatarHidden"
  ]);
  return /* @__PURE__ */ react.createElement(Card_es/* Card */.Z, SellerCard_es_spreadValues({}, props), /* @__PURE__ */ react.createElement(dist/* Flex */.kC, null, isAvatarHidden ? null : /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    marginRight: "8px",
    width: `${mapAvatarSize[avatarSize]}px`,
    style: { borderWidth: 1 }
  }, /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
    height: mapAvatarSize[avatarSize],
    width: mapAvatarSize[avatarSize],
    imageWidth: 100,
    src: avatar,
    aspectRatio: 1,
    contain: true,
    borderRadius: 999,
    border: true
  })), /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    alignItems: "flex-start",
    flexDirection: "column",
    justifyContent: "center"
  }, link ? /* @__PURE__ */ react.createElement(MobileLink_es/* MobileLink */.x, {
    href: link
  }, /* @__PURE__ */ react.createElement("a", {
    target: "_blank",
    style: { color: "unset", textDecoration: "unset" }
  }, /* @__PURE__ */ react.createElement(SellerName, null, name, " ", showTick && /* @__PURE__ */ react.createElement(StyledTick, null)))) : /* @__PURE__ */ react.createElement(SellerName, null, name, " ", showTick && !isAvatarHidden && /* @__PURE__ */ react.createElement(StyledTick, null)), slogan && showSlogan && /* @__PURE__ */ react.createElement(Slogan, null, slogan))));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/configs/theme.es.js
var theme_es = __webpack_require__(349055);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/PricePackage/PricePackage.es.js



const PricePackage_es_Container = styled_es/* styled.div */.z.div`
  display: flex;
  flex-wrap: wrap;
`;
const PricePackage_es_Wrapper = styled_es/* styled.div */.z.div(({ isSelected, isPackage }) => `
  display: flex;
  cursor: pointer;
  margin: 0.25rem 0.5rem 0.25rem 0;
  flex-direction: column;
  position: relative;
  ${isSelected ? `border: 1px solid ${theme_es/* theme.brand.primary */.r.brand.primary};` : ""}
  ${isPackage ? `
  min-width: 30%;
  border: 1px solid #e4e5f0;
  height: 76px;
  background: #fbfbfd;
  box-sizing: border-box;
  border-radius: 0.5rem;
  margin-right: 0.5rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 0.5rem;
  ` : ""} 
  `);
const PriceTag = styled_es/* styled.span */.z.span(({ isSelected }) => `
position: absolute;
top: 0;
width: fit-content;
background: #bcbfd6;
border-radius: 0px 0px 4px 4px;
color: #fff;
font-weight: 500;
font-size: 12px;
line-height: 16px;
padding: 2px 8px;
${isSelected && `background: ${theme_es/* theme.brand.primary */.r.brand.primary};`}
`);
const PricePackage_es_PriceWrapper = styled_es/* styled.div */.z.div(({ hasTag }) => `
    ${hasTag && `margin-top: 18px;`}
`);
const PricePackage_es_Price = styled_es/* styled.div */.z.div(({ isSelected, isPackage }) => `
    color: ${isSelected ? `${theme_es/* theme.colors.blue600 */.r.colors.blue600};` : " #82869E;"}
    font-weight: bold;
    font-size: ${isPackage ? "20px" : "24px"};
    line-height: 28px;
`);
const ListedPrice = styled_es/* styled.div */.z.div`
  font-size: 13px;
  line-height: 18px;
`;
const SupplierSalePrice = (0,styled_es/* styled */.z)(Currency_es/* Currency */.F)`
  color: #82869e;
  text-decoration: line-through;
`;
const PricePackage = ({
  prices,
  selectedPrice,
  setSelectedPrice,
  selectionPromotions
}) => {
  return /* @__PURE__ */ react.createElement(PricePackage_es_Container, null, prices.map((price, index) => /* @__PURE__ */ react.createElement(PricePackage_es_Wrapper, {
    isPackage: prices.length > 1 || ((selectionPromotions == null ? void 0 : selectionPromotions.length) || 0) > 1,
    isSelected: prices.length > 1 && selectedPrice === price.sellPrice,
    key: index,
    onClick: () => setSelectedPrice == null ? void 0 : setSelectedPrice(price.sellPrice === null ? null : Number(price.sellPrice))
  }, price.tag && /* @__PURE__ */ react.createElement(PriceTag, {
    isSelected: selectedPrice === price.sellPrice
  }, price.tag), /* @__PURE__ */ react.createElement(PricePackage_es_PriceWrapper, {
    hasTag: !!price.tag
  }, /* @__PURE__ */ react.createElement(PricePackage_es_Price, {
    isSelected: selectedPrice === price.sellPrice,
    isPackage: prices.length > 1 || ((selectionPromotions == null ? void 0 : selectionPromotions.length) || 0) > 1
  }, /* @__PURE__ */ react.createElement(Currency_es/* Currency */.F, {
    value: price.sellPrice || 0
  })), price.supplierSalePrice && price.supplierSalePrice !== price.sellPrice && /* @__PURE__ */ react.createElement(ListedPrice, null, /* @__PURE__ */ react.createElement(SupplierSalePrice, {
    value: price.supplierSalePrice
  }))))));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/PromotionPackage/PromotionDetail.es.js






const Quantity = styled_es/* styled.span */.z.span`
  font-size: 0.75rem;
  color: #848788;
  margin-right: 4px;
`;
const Benefit = styled_es/* styled.div */.z.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const Label = styled_es/* styled.div */.z.div`
  font-size: 0.75rem;
  flex: 1;
`;
const Coupon = styled_es/* styled.div */.z.div`
  text-transform: uppercase;
  padding: 0 6px;
  margin: 0 4px;
  background-color: #ef2741;
  color: #fff;
  border-radius: 2px;
  display: inline-block;
`;
const GiftImage = styled_es/* styled.div */.z.div`
  width: 32px;
  height: 32px;
  margin-right: 12px;
`;
const Discount = (0,styled_es/* styled */.z)(Currency_es/* Currency */.F)`
  margin-left: 4px;
  font-weight: bold;
`;
const PromotionDetail_es_PriceWrapper = styled_es/* styled.div */.z.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const GiftWrapper = (0,styled_es/* styled */.z)(PromotionDetail_es_PriceWrapper)`
  margin-top: 8px;
`;
const PromotionIcon = styled_es/* styled.div */.z.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
  margin-right: 12px;
`;
const Applied = styled_es/* styled.div */.z.div`
  background: #30cd60;
  border-radius: 4px;
  padding: 2px 4px;
  color: #ffffff;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  display: inline-block;
`;
const PromotionDetail = ({
  promotion,
  className
}) => {
  var _a, _b;
  return /* @__PURE__ */ react.createElement(Benefit, {
    className
  }, promotion.type === types_es/* PromotionType.PRODUCT */.q.PRODUCT ? /* @__PURE__ */ react.createElement(react.Fragment, null, promotion.benefit.money && !!promotion.benefit.money && promotion.benefit.money.map((moneyPromotion) => /* @__PURE__ */ react.createElement(Label, {
    key: moneyPromotion.id
  }, (0,i18n_es.t)("Gi\u1EA3m tr\u1EF1c ti\u1EBFp"), " ", /* @__PURE__ */ react.createElement(Discount, {
    value: moneyPromotion.money || 0
  }), " ", /* @__PURE__ */ react.createElement(Applied, null, (0,i18n_es.t)("\u0110\xE3 \xE1p d\u1EE5ng")))), promotion.benefit.items && !!promotion.benefit.items && promotion.benefit.items.map((gift) => {
    var _a2;
    return /* @__PURE__ */ react.createElement(GiftWrapper, {
      key: gift.name
    }, /* @__PURE__ */ react.createElement(GiftImage, null, /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
      borderRadius: 4,
      contain: true,
      src: ((_a2 = gift.image) == null ? void 0 : _a2.src) || ""
    })), /* @__PURE__ */ react.createElement(Quantity, null, "x", gift.quantity), /* @__PURE__ */ react.createElement(Label, null, gift.name));
  })) : /* @__PURE__ */ react.createElement(GiftWrapper, null, /* @__PURE__ */ react.createElement(PromotionIcon, null, /* @__PURE__ */ react.createElement(SvgIcon_es/* SvgIcon */.l, {
    name: "promotion",
    size: 16,
    color: "#1435c3"
  })), /* @__PURE__ */ react.createElement(Label, null, (0,i18n_es.t)("\u0110\xE3 \xE1p d\u1EE5ng m\xE3 gi\u1EA3m gi\xE1"), " ", /* @__PURE__ */ react.createElement(Coupon, null, " ", (_a = promotion.condition) == null ? void 0 : _a.coupon, " "), " ", (0,i18n_es.t)("gi\u1EA3m"), /* @__PURE__ */ react.createElement(PromotionInfo_es/* PromotionInfo */.z, {
    money: (_b = promotion.benefit.money) == null ? void 0 : _b[0],
    condition: promotion.condition || null
  }))));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/ProductDetail/ProductSpecifications/Specifications/Specifications.es.js
var Specifications_es = __webpack_require__(139676);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Dropdown/Dropdown.es.js
var Dropdown_es = __webpack_require__(929556);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/ComboImage/ComboImage.es.js
var ComboImage_es = __webpack_require__(287037);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Dropdown/DropdownToggle.es.js
var DropdownToggle_es = __webpack_require__(437753);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Dropdown/DropdownMenu.es.js
var DropdownMenu_es = __webpack_require__(332762);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/Gift/Gift.es.js
var Gift_es = __webpack_require__(343297);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/Variants/Variants.es.js



const Variants_es_Wrapper = styled_es/* styled.div */.z.div`
  color: #848788;
  font-size: 0.875rem;
  display: flex;
  flex-wrap: wrap;
`;
const Variant = styled_es/* styled.div */.z.div`
  display: flex;
`;
const Variants_es_Divider = styled_es/* styled.span */.z.span`
  margin: 0 8px;
  color: #848788;
`;
const Variants = ({
  variants = []
}) => /* @__PURE__ */ react.createElement(Variants_es_Wrapper, null, variants.map((variant, index) => /* @__PURE__ */ react.createElement(Variant, {
  key: index
}, /* @__PURE__ */ react.createElement("div", null, variant.name, ": ", variant.value), index !== variants.length - 1 && /* @__PURE__ */ react.createElement(Variants_es_Divider, null, "|"))));



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductInfo/ProductInfo.es.js







var ProductInfo_es_defProp = Object.defineProperty;
var ProductInfo_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var ProductInfo_es_hasOwnProp = Object.prototype.hasOwnProperty;
var ProductInfo_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var ProductInfo_es_defNormalProp = (obj, key, value) => key in obj ? ProductInfo_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var ProductInfo_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (ProductInfo_es_hasOwnProp.call(b, prop))
      ProductInfo_es_defNormalProp(a, prop, b[prop]);
  if (ProductInfo_es_getOwnPropSymbols)
    for (var prop of ProductInfo_es_getOwnPropSymbols(b)) {
      if (ProductInfo_es_propIsEnum.call(b, prop))
        ProductInfo_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ProductInfo_es_Wrapper = styled_es/* styled.div */.z.div`
  display: flex;
`;
const ProductName = styled_es/* styled.p */.z.p`
  padding: 0;
  margin: 0;
  font-size: 0.875rem;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const ProductInfo_es_Left = styled_es/* styled.div */.z.div`
  display: flex;
  align-items: center;
`;
const Right = styled_es/* styled.div */.z.div`
  flex: 1;
  margin-left: 1rem;
`;
const Action = styled_es/* styled.span */.z.span(({ mgl = true }) => `
      font-size: 14px;
      color: #047fff;
      margin-left: ${mgl ? "1.5rem" : 0};
      cursor: pointer;
      display: inline-block;
      width: max-content;
      flex-shrink: 0;
    `);
const ComboList = styled_es/* styled.ul */.z.ul`
  padding: 0.25rem 0.75rem;
  list-style-type: none;
  border-radius: 0.5rem;
  box-shadow: 0 2px 0.5rem 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  background-color: white;
  margin: 0;
  width: max-content;
  max-width: 25rem;
`;
const StyledDropdown = (0,styled_es/* styled */.z)(Dropdown_es/* Dropdown */.L)`
  width: max-content;
`;
const popperConfig = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, 10]
      }
    }
  ]
};
const StyledGift = (0,styled_es/* styled */.z)(Gift_es/* Gift */.n)`
  margin: 0.5rem 0;
`;
const SKU = styled_es/* styled.div */.z.div`
  color: #848788;
  font-size: 0.875rem;
`;
const ProductInfo = ({
  product: {
    sku,
    imageUrl,
    name,
    variants = [],
    combos = [],
    link,
    childItems = []
  },
  className
}) => {
  const [comboOpen, setComboOpen] = (0,react.useState)(false);
  const isCombo = childItems.length > 0;
  const toggleCombo = () => {
    setComboOpen((prev) => !prev);
  };
  const image = isCombo ? /* @__PURE__ */ react.createElement(ComboImage_es/* ComboImage */.Z, {
    images: (0,index_es/* getComboImageUrl */.B1)(childItems)
  }) : /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
    height: 80,
    width: 80,
    contain: true,
    border: true,
    src: imageUrl,
    alt: "product"
  });
  const productName = isCombo ? (0,index_es/* getComboName */.AK)(childItems) : name;
  return /* @__PURE__ */ react.createElement(ProductInfo_es_Wrapper, {
    className
  }, /* @__PURE__ */ react.createElement(ProductInfo_es_Left, null, image), /* @__PURE__ */ react.createElement(Right, null, /* @__PURE__ */ react.createElement(MobileLink_es/* MobileLink */.x, ProductInfo_es_spreadValues({}, link), /* @__PURE__ */ react.createElement("a", {
    target: "_blank",
    style: { color: "unset", textDecoration: "unset" }
  }, /* @__PURE__ */ react.createElement(ProductName, null, productName))), sku && /* @__PURE__ */ react.createElement(SKU, null, "SKU: ", sku), !!variants.length && /* @__PURE__ */ react.createElement(Variants, {
    variants
  }), !!combos.length && /* @__PURE__ */ react.createElement(StyledDropdown, {
    isOpen: comboOpen,
    toggle: toggleCombo,
    toggleType: "hover"
  }, /* @__PURE__ */ react.createElement(DropdownToggle_es/* DropdownToggle */.Z, {
    toggleType: "hover"
  }, /* @__PURE__ */ react.createElement(Action, {
    mgl: false
  }, "Xem combo")), /* @__PURE__ */ react.createElement(DropdownMenu_es/* DropdownMenu */.h, {
    popperConfig,
    origin: "left top"
  }, /* @__PURE__ */ react.createElement(ComboList, null, combos.map(({ imageUrl: imageUrl2, name: name2 }, index) => /* @__PURE__ */ react.createElement(StyledGift, {
    key: index,
    image: {
      src: imageUrl2
    },
    text: name2
  })))))));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Cart/CartLinePrint/CartLinePrint.es.js






var CartLinePrint_es_defProp = Object.defineProperty;
var CartLinePrint_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var CartLinePrint_es_hasOwnProp = Object.prototype.hasOwnProperty;
var CartLinePrint_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var CartLinePrint_es_defNormalProp = (obj, key, value) => key in obj ? CartLinePrint_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var CartLinePrint_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (CartLinePrint_es_hasOwnProp.call(b, prop))
      CartLinePrint_es_defNormalProp(a, prop, b[prop]);
  if (CartLinePrint_es_getOwnPropSymbols)
    for (var prop of CartLinePrint_es_getOwnPropSymbols(b)) {
      if (CartLinePrint_es_propIsEnum.call(b, prop))
        CartLinePrint_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var CartLinePrint_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (CartLinePrint_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && CartLinePrint_es_getOwnPropSymbols)
    for (var prop of CartLinePrint_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && CartLinePrint_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CartLinePrint_es_StyledCard = (0,styled_es/* styled */.z)(Card_es/* Card */.Z)`
  padding: 1rem;
`;
const CartLinePrint_es_StyledProductPrice = (0,styled_es/* styled */.z)(ProductPrice_es/* ProductPrice */.j)`
  text-align: right;
  justify-content: flex-end;
`;
const CartLinePrint_es_StyledGift = (0,styled_es/* styled */.z)(Gift_es/* Gift */.n)`
  margin: 0.5rem 0;
`;
const GiftBlock = styled_es/* styled.div */.z.div`
  margin-left: 3rem;
`;
const CartLinePrint = (_a) => {
  var _b = _a, {
    product
  } = _b, props = CartLinePrint_es_objRest(_b, [
    "product"
  ]);
  return /* @__PURE__ */ react.createElement(CartLinePrint_es_StyledCard, CartLinePrint_es_spreadValues({}, props), /* @__PURE__ */ react.createElement(Row_es/* Row */.X, null, /* @__PURE__ */ react.createElement(Col_es/* Col */.J, {
    col: 7
  }, /* @__PURE__ */ react.createElement(ProductInfo, {
    product
  })), /* @__PURE__ */ react.createElement(Col_es/* Col */.J, {
    col: 2.5
  }, /* @__PURE__ */ react.createElement("span", null, "x", product.quantity)), /* @__PURE__ */ react.createElement(Col_es/* Col */.J, {
    col: 2.5
  }, /* @__PURE__ */ react.createElement(CartLinePrint_es_StyledProductPrice, {
    listedPrice: product.price,
    price: product.discountPrice
  }))), !!(product.gifts || []).length && /* @__PURE__ */ react.createElement(Row_es/* Row */.X, null, /* @__PURE__ */ react.createElement(Col_es/* Col */.J, {
    col: 7
  }, /* @__PURE__ */ react.createElement(GiftBlock, null, product.gifts.map((gift, index) => /* @__PURE__ */ react.createElement(CartLinePrint_es_StyledGift, {
    key: index,
    image: {
      src: gift.imageUrl
    },
    text: gift.name
  }))))));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Cart/CartNumberTracking/CartNumberTracking.es.js
var CartNumberTracking_es = __webpack_require__(279835);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Checkout/ProductCheckoutInfo/ProductCheckoutInfo.es.js
var ProductCheckoutInfo_es = __webpack_require__(872440);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcItem/BuildPcItem.es.js
var BuildPcItem_es = __webpack_require__(123579);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcModal/BuildPcModalContent.es.js
var BuildPcModalContent_es = __webpack_require__(433329);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcModal/BuildPcModalHeader.es.js
var BuildPcModalHeader_es = __webpack_require__(14956);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcModal/BuildPcModal.es.js





const BuildPcModal = ({
  filters,
  products,
  activeValues = [],
  onClickFilter,
  onClickSort,
  onClickProduct,
  loading = false,
  searchParams
}) => /* @__PURE__ */ react.createElement(Card_es/* Card */.Z, null, /* @__PURE__ */ react.createElement(BuildPcModalHeader_es/* BuildPcModalHeader */.t, {
  searchParams,
  onClickSort,
  onClickFilter: onClickFilter || (() => {
  }),
  filters,
  activeValues
}), /* @__PURE__ */ react.createElement(BuildPcModalContent_es/* BuildPcModalContent */.b, {
  isLoading: loading,
  onClick: onClickProduct || (() => {
  }),
  products
}));



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcTabs/BuildPcTabs.es.js
var BuildPcTabs_es = __webpack_require__(562194);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcSummary/BuildPcSummary.es.js + 1 modules
var BuildPcSummary_es = __webpack_require__(924780);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/PrintBuildPc/PrintBuildPc.es.js
var PrintBuildPc_es = __webpack_require__(327601);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/PrintBuildPc/PrintBuildPcItem.es.js
var PrintBuildPcItem_es = __webpack_require__(523691);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcNumberStepper/BuildPcNumberStepper.es.js
var BuildPcNumberStepper_es = __webpack_require__(260613);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Tag/Tag.es.js
var Tag_Tag_es = __webpack_require__(991822);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/OrderDetail/TableDivider/TableDivider.es.js
var TableDivider_es = __webpack_require__(200666);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/OrderList/OrderList.es.js







var OrderList_es_defProp = Object.defineProperty;
var OrderList_es_defProps = Object.defineProperties;
var OrderList_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var OrderList_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var OrderList_es_hasOwnProp = Object.prototype.hasOwnProperty;
var OrderList_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var OrderList_es_defNormalProp = (obj, key, value) => key in obj ? OrderList_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var OrderList_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (OrderList_es_hasOwnProp.call(b, prop))
      OrderList_es_defNormalProp(a, prop, b[prop]);
  if (OrderList_es_getOwnPropSymbols)
    for (var prop of OrderList_es_getOwnPropSymbols(b)) {
      if (OrderList_es_propIsEnum.call(b, prop))
        OrderList_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var OrderList_es_spreadProps = (a, b) => OrderList_es_defProps(a, OrderList_es_getOwnPropDescs(b));
const Table = styled_es/* styled.table */.z.table`
  background-color: #fff;
  border-radius: 8px;
  width: 100%;
  border-spacing: 0;

  thead {
    text-align: left;
    th {
      border-bottom: 1px solid #e0e0e0;
      padding: 16px;
      font-size: 16px;
      font-weight: 700;
      color: #333;
    }
  }

  tbody {
    td {
      font-size: 14px;
      padding: 16px;
      width: max-content;
      vertical-align: top;
    }

    tr {
      &:first-of-type {
        margin-left: 16px;
      }
      &:last-child {
        margin-right: 16px;
      }
    }
  }
`;
const OrderID = styled_es/* styled.a */.z.a`
  cursor: pointer;
  text-decoration: none;

  &:link,
  &:visited {
    color: #047fff;
  }

  &:hover {
    color: #0058b5;
  }
`;
const TableData = styled_es/* styled.td */.z.td(({ direction }) => `
  text-align: ${direction}
`);
const TableHead = styled_es/* styled.th */.z.th(({ direction, width }) => `
  text-align: ${direction};
  width: ${width ? `${width}%` : "initial"};
`);
const OrderList_es_ProductName = styled_es/* styled.th */.z.th`
  width: 36%;
  max-width: 40%;
`;
const Name = styled_es/* styled.div */.z.div(({ lineclamp }) => `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${lineclamp};
  -webkit-box-orient: vertical;
`);
const OrderList = ({
  orders,
  lineclamp = 1,
  linkExtractor,
  showOriginalCode
}) => {
  if (!orders.length)
    return null;
  return /* @__PURE__ */ react.createElement("div", {
    style: { minHeight: 550 }
  }, /* @__PURE__ */ react.createElement(Table, null, /* @__PURE__ */ react.createElement("thead", null, /* @__PURE__ */ react.createElement("tr", null, /* @__PURE__ */ react.createElement("th", null, (0,i18n_es.t)("M\xE3 \u0111\u01A1n h\xE0ng")), /* @__PURE__ */ react.createElement("th", null, (0,i18n_es.t)("Ng\xE0y mua")), /* @__PURE__ */ react.createElement(OrderList_es_ProductName, null, (0,i18n_es.t)("S\u1EA3n ph\u1EA9m")), /* @__PURE__ */ react.createElement(TableHead, {
    direction: "right"
  }, (0,i18n_es.t)("T\u1ED5ng ti\u1EC1n (\u0111)")), /* @__PURE__ */ react.createElement(TableHead, {
    direction: "right",
    width: 16
  }, (0,i18n_es.t)("Tr\u1EA1ng th\xE1i")))), /* @__PURE__ */ react.createElement("tbody", null, orders.map((order, index) => {
    var _a;
    const showLink = !!(linkExtractor && ((_a = linkExtractor(order)) == null ? void 0 : _a.href));
    const clearanceTypeTag = order.productClearanceTypeTag;
    return /* @__PURE__ */ react.createElement(react.Fragment, {
      key: index
    }, /* @__PURE__ */ react.createElement("tr", null, /* @__PURE__ */ react.createElement("td", null, showLink ? /* @__PURE__ */ react.createElement((link_default()), OrderList_es_spreadProps(OrderList_es_spreadValues({}, linkExtractor(order)), {
      legacyBehavior: true
    }), /* @__PURE__ */ react.createElement(OrderID, null, showOriginalCode && order.originalCode || order.code)) : showOriginalCode && order.originalCode || order.code), /* @__PURE__ */ react.createElement("td", null, order.date), /* @__PURE__ */ react.createElement("td", null, /* @__PURE__ */ react.createElement(Name, {
      lineclamp
    }, clearanceTypeTag && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Tag_Tag_es/* Tag */.V, {
      type: "secondary",
      variant: "branding",
      content: clearanceTypeTag
    }), "\xA0"), order.name)), /* @__PURE__ */ react.createElement(TableData, {
      direction: "right"
    }, /* @__PURE__ */ react.createElement(Currency_es/* Currency */.F, {
      value: order.price,
      hideCurrency: true
    })), /* @__PURE__ */ react.createElement(TableData, {
      direction: "right"
    }, order.renderStatus)), index !== orders.length - 1 ? /* @__PURE__ */ react.createElement(TableDivider_es/* TableDivider */.E, {
      colCount: 5,
      mr: 16,
      ml: 16
    }) : null);
  }))));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/OrderDetail/DetaiInfo/DetailInfo.es.js



const Field = styled_es/* styled.p */.z.p`
  line-height: 20px;
  margin-bottom: 0;
`;
const Key = styled_es/* styled.span */.z.span`
  font-size: 14px;
  font-weight: 700;
`;
const DetailInfo_es_Value = styled_es/* styled.span */.z.span(({ color }) => `
    font-weight: 400;
    color: ${color}
`);
const DetailInfo = ({
  field,
  color = "#333",
  value
}) => /* @__PURE__ */ react.createElement(Field, null, /* @__PURE__ */ react.createElement(Key, null, field, ": "), /* @__PURE__ */ react.createElement(DetailInfo_es_Value, {
  color
}, value));



// EXTERNAL MODULE: ../../packages/slug/dist/index.es.js
var dist_index_es = __webpack_require__(93512);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/OrderDetail/DetailTable/DetailTable.es.js







const OrderItemsWrapper = styled_es/* styled.table */.z.table`
  margin-top: 16px;
  border-radius: 8px;
  background-color: white;
  overflow: hidden;
  font-size: 14px;
  color: #333;
  border-spacing: 0;
  width: 100%;
  border-collapse: initial;

  p {
    margin: 0;
    padding: 0;
  }

  td {
    vertical-align: top;
  }

  th {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    border-bottom: 1px solid #e0e0e0;
    padding: 16px;
    &:nth-of-type(1) {
      width: 52%;
    }

    &:nth-of-type(2) {
      width: 17%;
    }

    &:nth-of-type(4) {
      width: 17%;
    }

    &:nth-of-type(5) {
      width: 14%;
    }
  }
`;
const OrderProduct = styled_es/* styled.tr */.z.tr`
  td {
    padding: 16px;
  }
`;
const ProductItem = styled_es/* styled.td */.z.td`
  display: flex;
  justify-content: space-between;
`;
const ProductItemRight = styled_es/* styled.div */.z.div`
  margin-left: 16px;

  & > :not(:last-child) {
    margin-bottom: 4px;
  }
`;
const ItemImg = (0,styled_es/* styled */.z)(LazyImage_es/* LazyImage */.w)`
  width: 56px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  margin: 0;
  padding: 0;
  max-width: 56px;
`;
const ItemName = styled_es/* styled.p */.z.p`
  word-wrap: break-word;
  line-height: 20px;
`;
const ItemSku = styled_es/* styled.p */.z.p`
  font-size: 14px;
  color: #848788;
  line-height: 20px;
  margin-top: 4px;
`;
const ItemPrice = styled_es/* styled.td */.z.td`
  text-align: right;
`;
const ItemFinalPrice = (0,styled_es/* styled */.z)(ItemPrice)`
  font-weight: 700;
`;
const ItemQuantity = styled_es/* styled.td */.z.td`
  text-align: center;
`;
const DetailTable_es_TableHead = styled_es/* styled.th */.z.th(({ direction }) => `
    text-align: ${direction};
    font-weight: 700 !important;
  `);
const OrderPrize = styled_es/* styled.tr */.z.tr`
  td {
    padding: 0 16px 8px 16px;
  }
`;
const PrizeItem = (0,styled_es/* styled */.z)(ProductItem)(({ last }) => `
    display: flex;
    padding-left: 40px !important;
    padding-bottom: ${last ? "16px !important" : ""};
  `);
const PrizeImg = (0,styled_es/* styled */.z)(ItemImg)`
  margin-right: 16px;
  width: 32px;
  height: 32px;
  max-width: 32px;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
`;
const PrizeName = (0,styled_es/* styled */.z)(ItemName)`
  font-size: 12px;
  line-height: 16px;
  color: #333;
`;
const DiscountWrapper = styled_es/* styled.div */.z.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
`;
const DetailTable_es_ListedPrice = (0,styled_es/* styled */.z)(Currency_es/* Currency */.F)(({ lineThrough, theme, size, horizontal }) => `
  text-decoration: ${lineThrough ? "line-through" : "none"};
  color: ${theme.colors.gray130};
  font-size: ${size === "md" ? "0.75rem" : "1.25rem"};
  margin-left: ${horizontal ? "6px" : ""};
`);
const DetailTable = ({
  products
}) => {
  return /* @__PURE__ */ react.createElement(OrderItemsWrapper, null, /* @__PURE__ */ react.createElement("thead", null, /* @__PURE__ */ react.createElement("tr", null, /* @__PURE__ */ react.createElement(DetailTable_es_TableHead, {
    direction: "left"
  }, (0,i18n_es.t)("S\u1EA3n ph\u1EA9m")), /* @__PURE__ */ react.createElement(DetailTable_es_TableHead, {
    direction: "right"
  }, (0,i18n_es.t)("Gi\xE1 tr\u1ECB")), /* @__PURE__ */ react.createElement(DetailTable_es_TableHead, {
    direction: "center"
  }, (0,i18n_es.t)("S\u1ED1 l\u01B0\u1EE3ng")), /* @__PURE__ */ react.createElement(DetailTable_es_TableHead, {
    direction: "right"
  }, (0,i18n_es.t)("T\u1ED5ng ti\u1EC1n")))), /* @__PURE__ */ react.createElement("tbody", null, products.map(({
    name,
    displayName,
    imageUrl,
    sku,
    price,
    unitPrice,
    quantity,
    finalPrice,
    prizes = []
  }, index) => /* @__PURE__ */ react.createElement(react.Fragment, {
    key: index
  }, /* @__PURE__ */ react.createElement(OrderProduct, null, /* @__PURE__ */ react.createElement(ProductItem, null, /* @__PURE__ */ react.createElement(ItemImg, {
    src: imageUrl,
    alt: "item"
  }), /* @__PURE__ */ react.createElement(ProductItemRight, null, /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, {
    targetPath: `/${(0,dist_index_es/* default */.Z)(name)}-s${sku}.html`,
    targetType: "_blank",
    passHref: true
  }, /* @__PURE__ */ react.createElement(ItemName, null, displayName || name)), /* @__PURE__ */ react.createElement(ItemSku, null, "SKU: ", sku))), /* @__PURE__ */ react.createElement(ItemPrice, null, /* @__PURE__ */ react.createElement(Currency_es/* Currency */.F, {
    space: true,
    underline: true,
    value: price
  }), unitPrice && unitPrice !== price && /* @__PURE__ */ react.createElement(DiscountWrapper, null, /* @__PURE__ */ react.createElement(DetailTable_es_ListedPrice, {
    horizontal: false,
    size: "md",
    value: unitPrice,
    lineThrough: true
  }))), /* @__PURE__ */ react.createElement(ItemQuantity, null, quantity.toLocaleString("vi-VN")), /* @__PURE__ */ react.createElement(ItemFinalPrice, null, /* @__PURE__ */ react.createElement(Currency_es/* Currency */.F, {
    space: true,
    underline: true,
    value: finalPrice
  }))), prizes.map(({ name: name2, imageUrl: imageUrl2, price: price2, quantity: quantity2 }, index2) => /* @__PURE__ */ react.createElement(OrderPrize, {
    key: index2
  }, /* @__PURE__ */ react.createElement(PrizeItem, {
    last: prizes.length - 1 === index2
  }, /* @__PURE__ */ react.createElement(PrizeImg, {
    src: imageUrl2,
    alt: "item"
  }), /* @__PURE__ */ react.createElement(PrizeName, null, name2)), /* @__PURE__ */ react.createElement(ItemPrice, null, /* @__PURE__ */ react.createElement(Currency_es/* Currency */.F, {
    space: true,
    underline: true,
    value: price2
  })), /* @__PURE__ */ react.createElement(ItemQuantity, null, quantity2.toLocaleString("vi-VN")))), index !== products.length - 1 && /* @__PURE__ */ react.createElement(TableDivider_es/* TableDivider */.E, {
    colCount: 4,
    ml: 116,
    mr: 16
  })))));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/OrderDetail/OrderProductList/OrderProductList.es.js
var OrderProductList_es = __webpack_require__(155850);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/BlockHeader/BlockHeader.es.js
var BlockHeader_BlockHeader_es = __webpack_require__(129892);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/OrderDetail/OrderPromotion/OrderPromotion.es.js






const PartOrderGiftWrapper = styled_es/* styled.div */.z.div`
  padding: 16px;
  background: #fff;
`;
const StyledBlockHeader = (0,styled_es/* styled */.z)(BlockHeader_BlockHeader_es/* BlockHeader */.t)`
  background: #f6f6f6;
`;
const OrderPromotion_es_StyledPromoItem = (0,styled_es/* styled */.z)(PromoItem_es/* PromoItem */.D)`
  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;
const OrderPromotion = ({
  orderPromotions,
  isMobile = false
}) => {
  let promotions = [];
  orderPromotions.forEach((promotion) => {
    if (promotion) {
      const { discount, gifts, voucher, quantity } = promotion;
      if (discount)
        promotions.push({
          text: (0,i18n_es.t)("{{quantity}}x Gi\u1EA3m gi\xE1 {{var0}}", {
            quantity,
            var0: (discount / quantity).toLocaleString("vi-VN", {
              style: "currency",
              currency: "VND"
            })
          }),
          type: PromoItem_es/* PromoItemType.DISCOUNT */.r.DISCOUNT
        });
      if (gifts == null ? void 0 : gifts.length) {
        promotions = [
          ...promotions,
          ...gifts.map((gift) => ({
            text: `${gift.quantity}x ${gift.name}`,
            type: PromoItem_es/* PromoItemType.GIFT */.r.GIFT,
            imgSrc: gift.imageUrl || ""
          }))
        ];
      }
      if (voucher == null ? void 0 : voucher.quantity)
        promotions.push({
          type: PromoItem_es/* PromoItemType.VOUCHER */.r.VOUCHER,
          text: (0,i18n_es.t)("{{VoucherQuantity}}x Voucher gi\u1EA3m gi\xE1 cho \u0111\u01A1n h\xE0ng sau", {
            VoucherQuantity: voucher.quantity
          })
        });
    }
  });
  return /* @__PURE__ */ react.createElement(react.Fragment, null, isMobile && /* @__PURE__ */ react.createElement(StyledBlockHeader, {
    title: {
      fontWeight: "500",
      fontSize: 14,
      color: "#848788"
    }
  }, (0,i18n_es.t)("KHUY\u1EBEN M\xC3I CHO \u0110\u01A0N H\xC0NG")), /* @__PURE__ */ react.createElement(PartOrderGiftWrapper, null, promotions.map(({ type, text, imgSrc }, index) => type !== PromoItem_es/* PromoItemType.DISCOUNT */.r.DISCOUNT && /* @__PURE__ */ react.createElement(OrderPromotion_es_StyledPromoItem, {
    key: index,
    type,
    text,
    imgSrc
  }))));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/OrderItem/OrderItem.es.js
var OrderItem_es = __webpack_require__(620714);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/Flex/Flex.es.js
var Flex_es = __webpack_require__(112288);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/ListItem/ListItem.es.js
var ListItem_es = __webpack_require__(646807);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/OrderDetail/OrderShipment/OrderShipment.es.js








const OrderShipment_es_Wrapper = styled_es/* styled.div */.z.div`
  border-radius: 8px;
  border: 1px solid #e4e5f0;
  padding: 4px;
  margin: 16px 16px;
`;
const ShipmentCodAmount = styled_es/* styled.div */.z.div`
  display: flex;
  align-items: center;
`;
const StyledFlex = (0,styled_es/* styled */.z)(Flex_es/* Flex */.k)`
  cursor: pointer;
`;
const OrderShipment = ({
  index,
  shipmentCode,
  shipmentId,
  status,
  statusColor,
  onClick,
  codAmount
}) => {
  return /* @__PURE__ */ react.createElement(OrderShipment_es_Wrapper, {
    key: index
  }, /* @__PURE__ */ react.createElement(ListItem_es/* ListItem */.H, {
    title: "",
    left: /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, null, /* @__PURE__ */ react.createElement(Text_es/* Text */.x, {
      fontWeight: "500"
    }, (0,i18n_es.t)("V\u1EADn \u0111\u01A1n {{index}}{{var0}}", {
      index,
      var0: shipmentCode ? `: ${shipmentCode}` : ""
    })), /* @__PURE__ */ react.createElement(react.Fragment, null, "\xA0"), /* @__PURE__ */ react.createElement(OrderItem_es/* OrderStatus */.i, {
      bgc: statusColor || "#F78212"
    }, status)), /* @__PURE__ */ react.createElement(StyledFlex, {
      alignItems: "center",
      marginTop: "8px",
      onClick: () => onClick == null ? void 0 : onClick(shipmentId)
    }, /* @__PURE__ */ react.createElement(Text_es/* Text */.x, {
      color: "#1990FF"
    }, (0,i18n_es.t)("Xem chi ti\u1EBFt v\u1EADn \u0111\u01A1n")), /* @__PURE__ */ react.createElement(react.Fragment, null, "\xA0"), /* @__PURE__ */ react.createElement(SvgIcon_es/* SvgIcon */.l, {
      name: "chevron-forward",
      size: 14,
      color: "#1990FF"
    }))),
    right: !!codAmount && /* @__PURE__ */ react.createElement(ShipmentCodAmount, null, /* @__PURE__ */ react.createElement(Text_es/* Text */.x, {
      marginLeft: "auto",
      marginRight: "4px",
      color: "#82869E",
      fontSize: 13
    }, (0,i18n_es.t)("C\u1EA7n thanh to\xE1n:")), /* @__PURE__ */ react.createElement(Text_es/* Text */.x, {
      paddingY: "8px",
      fontSize: 16,
      color: "#D60F29",
      fontWeight: "500"
    }, codAmount.toLocaleString("vi-VN", {
      style: "currency",
      currency: "VND"
    })))
  }));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/OrderDetail/EditableDetailTable/EditableDetailTable.es.js
var EditableDetailTable_es = __webpack_require__(569907);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/OrderDetail/PromoTable/PromoTable.es.js





const OrderPromo = styled_es/* styled.table */.z.table`
  background-color: white;
  border-radius: 8px;
  margin-top: 16px;
  width: 100%;
  border-spacing: 0;

  thead th {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }

  td,
  th {
    padding: 16px;
  }
`;
const PromoTable_es_TableHead = styled_es/* styled.th */.z.th(({ direction, pdLeft = false }) => `
    padding-left: ${pdLeft ? "116px" : ""};
    text-align: ${direction};
    font-weight: 700 !important;
  `);
const TableDataPromo = styled_es/* styled.td */.z.td`
  padding-left: 116px;
`;
const PromoTable_es_Price = styled_es/* styled.td */.z.td`
  text-align: right;
`;
const PromoTable_es_TableData = styled_es/* styled.td */.z.td(({ direction }) => `
  text-align: ${direction}
`);
const PromoTable = ({
  promos
}) => {
  return /* @__PURE__ */ react.createElement(OrderPromo, null, /* @__PURE__ */ react.createElement("thead", null, /* @__PURE__ */ react.createElement("tr", null, /* @__PURE__ */ react.createElement(PromoTable_es_TableHead, {
    direction: "left",
    pdLeft: true
  }, (0,i18n_es.t)("Khuy\u1EBFn m\xE3i cho \u0111\u01A1n h\xE0ng")), /* @__PURE__ */ react.createElement(PromoTable_es_TableHead, {
    direction: "right"
  }, (0,i18n_es.t)("Gi\xE1 tr\u1ECB")), /* @__PURE__ */ react.createElement(PromoTable_es_TableHead, {
    direction: "center"
  }, (0,i18n_es.t)("S\u1ED1 l\u01B0\u1EE3ng")), /* @__PURE__ */ react.createElement(PromoTable_es_TableHead, {
    direction: "right"
  }, (0,i18n_es.t)("T\u1EA1m t\xEDnh")))), /* @__PURE__ */ react.createElement("tbody", null, promos.map(({ name, price, quantity, total = 0 }, index) => /* @__PURE__ */ react.createElement(react.Fragment, {
    key: index
  }, /* @__PURE__ */ react.createElement("tr", null, /* @__PURE__ */ react.createElement(TableDataPromo, null, name), /* @__PURE__ */ react.createElement(PromoTable_es_Price, null, /* @__PURE__ */ react.createElement(Currency_es/* Currency */.F, {
    value: price,
    space: true,
    underline: true
  })), /* @__PURE__ */ react.createElement(PromoTable_es_TableData, {
    direction: "center"
  }, quantity), /* @__PURE__ */ react.createElement(PromoTable_es_TableData, {
    direction: "right"
  }, /* @__PURE__ */ react.createElement(Currency_es/* Currency */.F, {
    value: total,
    space: true,
    underline: true
  }))), index !== promos.length - 1 && /* @__PURE__ */ react.createElement(TableDivider_es/* TableDivider */.E, {
    colCount: 4,
    ml: 16,
    mr: 16
  })))));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/OrderDetail/Stepper/Stepper.es.js



const ProgressBarWrapper = styled_es/* styled.div */.z.div``;
const Bar = styled_es/* styled.div */.z.div`
  height: 4px;
  background-color: #e0e0e0;
  width: 600px;
  position: relative;
  margin: 0 auto;
`;
const Stepper_es_Progress = styled_es/* styled.div */.z.div(({ width, variant }) => `
    position: absolute;
    height: 4px;
    left: 0;
    top: 0;
    background-image: ${variant === "danger" ? "linear-gradient(to right,#ff0024,#c31414)" : "linear-gradient(to right, #0064ff, #1435c3)"};
    width: ${width}%;
  `);
const Dot = styled_es/* styled.div */.z.div(({ status, left, variant }) => `
    width: ${status === "active" ? "32px" : "16px"};
    height: ${status === "active" ? "32px" : "16px"};
    position: absolute;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    background-color: ${status === "inactive" ? "#e0e0e0" : `${variant === "danger" ? "rgba(235, 33, 1, 0.25)" : "rgba(20, 53, 195, 0.25)"}`};

    left: ${left}%;
  `);
const DotCenter = styled_es/* styled.div */.z.div(({ status, variant }) => `
    width: ${status === "active" ? "20px" : "10px"};
    height: ${status === "active" ? "20px" : "10px"};
    background-color: ${status === "inactive" ? "#9b9b9b" : `${variant === "danger" ? "#eb2101" : "#1435c3"}`};
    border-radius: 50%;
    box-shadow: ${status === "active" ? `${variant === "danger" ? "0 0 0 0 rgba(235, 33, 1, 1)" : "0 0 0 0 rgb(20, 53, 195, 1)"}` : ""};
    transform: scale(1);
    animation: ${status === "active" ? "dot-pulse" : null};
    animation-duration: 2s;
    animation-iteration-count: infinite;

    @keyframes dot-pulse {
      0% {
        transform: scale(0.9);
        box-shadow: ${variant === "danger" ? "0 0 0 0 rgba(235, 33, 1,  0.7)" : "0 0 0 0 rgba(20, 53, 195, 0.7)"};
      }

      70% {
        transform: scale(1);
        box-shadow: ${variant === "danger" ? "0 0 0 6px rgba(235, 33, 1,  0)" : "0 0 0 6px rgba(20, 53, 195, 0)"};
      }

      100% {
        transform: scale(0.9);
        box-shadow: ${variant === "danger" ? "0 0 0 0 rgba(235, 33, 1,  0)" : "0 0 0 0 rgba(20, 53, 195, 0)"};
      }
    }
  `);
const ContentWrapper = styled_es/* styled.div */.z.div(({ left }) => `
    position: absolute;
    top: 28px;
    transform: translateX(-50%);
    width: max-content;
    text-align: center;
    left: ${left}%;
  `);
const Status = styled_es/* styled.p */.z.p(({ active }) => `
    font-size: 14px;
    color: #333;
    letter-spacing: -0.4px;
    margin-bottom: 4px;
    font-weight: ${active ? "700" : ""};
  `);
const FinishedDate = styled_es/* styled.p */.z.p(({ active }) => `
    font-size: 12px;
    color: ${active ? "#333" : "#848788"};
    margin: 0;
  `);
const Stepper = ({
  steps,
  currentStep,
  variant
}) => {
  return /* @__PURE__ */ react.createElement(ProgressBarWrapper, null, /* @__PURE__ */ react.createElement(Bar, null, /* @__PURE__ */ react.createElement(Stepper_es_Progress, {
    width: currentStep * 100 / (steps.length - 1),
    variant
  }), steps.map((step, index) => {
    const status = index > currentStep ? "inactive" : index === currentStep ? "active" : null;
    return /* @__PURE__ */ react.createElement(Dot, {
      status,
      left: index * (100 / (steps.length - 1)),
      key: index,
      variant
    }, /* @__PURE__ */ react.createElement(DotCenter, {
      status,
      variant
    }));
  }), steps.map(({ status, date }, index) => /* @__PURE__ */ react.createElement(ContentWrapper, {
    left: index * (100 / (steps.length - 1)),
    key: index
  }, /* @__PURE__ */ react.createElement(Status, {
    active: index === currentStep
  }, status), date && /* @__PURE__ */ react.createElement(FinishedDate, {
    active: index === currentStep
  }, date)))));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/OrderDetail/OrderProductLine/OrderProductLine.es.js
var OrderProductLine_es = __webpack_require__(481549);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/CampaignItem/CampaignItem.es.js
var CampaignItem_es = __webpack_require__(16991);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/ImageGallery/ImageGallery.es.js
var ImageGallery_es = __webpack_require__(905958);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/ProductImagesMobile/ProductImagesMobile.es.js
var ProductImagesMobile_es = __webpack_require__(29978);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/ProductDetail/ProductSpecificationsMobile.es.js
var ProductSpecificationsMobile_es = __webpack_require__(779436);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/ProductDetail/ProductShortDescriptionMobile.es.js
var ProductShortDescriptionMobile_es = __webpack_require__(679311);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/ProductDetail/ProductHeaderMobile.es.js
var ProductHeaderMobile_es = __webpack_require__(558773);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/ProductDetail/VariantItem.es.js
var VariantItem_es = __webpack_require__(390368);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/ProductDetail/ProductVariantsMobile.es.js
var ProductVariantsMobile_es = __webpack_require__(333577);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/NavBar/NavBarWithTitle.es.js
var NavBarWithTitle_es = __webpack_require__(458205);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/NavBar/NavBarWithSearchBox.es.js
var NavBarWithSearchBox_es = __webpack_require__(964019);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/NavBar/NavBarDropDown.es.js
var NavBarDropDown_es = __webpack_require__(15529);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/NavBar/DetailNavBar.es.js
var DetailNavBar_es = __webpack_require__(432283);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/index.es.js




































































































/***/ }),

/***/ 547425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Gallery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(279215);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(885525);
/* harmony import */ var _Swiper_Swiper_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(732553);
/* harmony import */ var _atoms_Container_Container_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(358277);
/* harmony import */ var _atoms_LazyImage_LazyImage_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(179185);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(650983);








const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ bgColor }) => `
  background-color: ${bgColor};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
`);
const Header = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  display: flex;
  justify-content: flex-end;
  height: 36px;
  align-items: center;
  z-index: 3;
`;
const Footer = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  margin: 1rem 0;
  z-index: 3;
  .swiper-slide {
    width: auto !important;
  }
  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }
`;
const StyledImage = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_LazyImage_LazyImage_es_js__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w)`
  position: initial;
  img {
    min-width: 100%;
    max-height: 100%;
  }
`;
const StyledSmallImage = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_LazyImage_LazyImage_es_js__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w)`
  background: #fff;
`;
const ImageWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  background: transparent;
  border: 0;
`;
const StyledContainer = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  height: calc(100vh - 130px);
  z-index: 4;
  width: 100%;
  > div,
  .swiper-container {
    height: 100%;
    width: 100%;
  }
  .swiper-wrapper {
    height: 100% !important;
    width: 100% !important;
  }
`;
const Thumbnail = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button */ .Z.button`
  transition: 0.1s ease opacity;
  text-align: center;
  background-color: transparent;
  border: 0;
  width: 60px !important;
  &:hover {
    opacity: 0.6;
  }
`;
const ButtonClose = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z)`
  align-self: flex-end;
`;
const Gallery = ({
  images,
  activeImageIndex,
  onClose,
  bgColor = "#000"
}) => {
  swiper_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .Z.use([swiper_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z]);
  const [thumbsSwiper, setThumbsSwiper] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    bgColor
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Header, null, onClose && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonClose, {
    onClick: onClose,
    link: true,
    icon: { name: "close", size: 26 }
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledContainer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Swiper_Swiper_es_js__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .t, {
    thumbs: { swiper: thumbsSwiper },
    initialSlide: activeImageIndex,
    hasNavigation: true,
    slidesPerView: 1,
    slidesPerGroup: 1
  }, images.map((image) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, {
    key: image.imageUrl,
    className: "swiper-slide"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, {
    contain: true,
    imageWidth: 1e3,
    src: image.imageUrl,
    alt: image.caption
  }))))), !!images.length && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Footer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_Container_Container_es_js__WEBPACK_IMPORTED_MODULE_7__/* .Container */ .W, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Swiper_Swiper_es_js__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .t, {
    className: "gallery-thumbs",
    onSwiper: setThumbsSwiper,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    spaceBetween: 10
  }, images.map((image, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Thumbnail, {
    key: index
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSmallImage, {
    src: image.thumbnailUrl || image.imageUrl,
    alt: image.caption,
    contain: true,
    width: 60,
    height: 60,
    imageWidth: 150,
    borderRadius: 4
  })))))));
};




/***/ }),

/***/ 72325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 885525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(796912);
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(996045);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Thumbs = {
  init: function init() {
    var swiper = this;
    var thumbsParams = swiper.params.thumbs;
    if (swiper.thumbs.initialized) return false;
    swiper.thumbs.initialized = true;
    var SwiperClass = swiper.constructor;

    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .extend */ .l7)(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .extend */ .l7)(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if ((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .isObject */ .Kn)(thumbsParams.swiper)) {
      swiper.thumbs.swiper = new SwiperClass((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .extend */ .l7)({}, thumbsParams.swiper, {
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: false
      }));
      swiper.thumbs.swiperCreated = true;
    }

    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    return true;
  },
  onThumbClick: function onThumbClick() {
    var swiper = this;
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    var clickedIndex = thumbsSwiper.clickedIndex;
    var clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    var slideToIndex;

    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt((0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }

    if (swiper.params.loop) {
      var currentIndex = swiper.activeIndex;

      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }

      var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
      var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
    }

    swiper.slideTo(slideToIndex);
  },
  update: function update(initial) {
    var swiper = this;
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
    var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      var currentThumbsIndex = thumbsSwiper.activeIndex;
      var newThumbsIndex;
      var direction;

      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix(); // eslint-disable-next-line

          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        } // Find actual thumbs index to slide to


        var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
        var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();

        if (typeof prevThumbsIndex === 'undefined') {
          newThumbsIndex = nextThumbsIndex;
        } else if (typeof nextThumbsIndex === 'undefined') {
          newThumbsIndex = prevThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = nextThumbsIndex;
        } else {
          newThumbsIndex = prevThumbsIndex;
        }

        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }

      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }

      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) {// newThumbsIndex = newThumbsIndex - slidesPerView + 1;
        }

        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    } // Activate thumbs


    var thumbsToActivate = 1;
    var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }

    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.removeClass(thumbActiveClass);

    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (var i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]").addClass(thumbActiveClass);
      }
    } else {
      for (var _i = 0; _i < thumbsToActivate; _i += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + _i).addClass(thumbActiveClass);
      }
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'thumbs',
  params: {
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-container-thumbs'
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .bindModuleMethods */ .cR)(swiper, {
      thumbs: _extends({
        swiper: null,
        initialized: false
      }, Thumbs)
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      var thumbs = swiper.params.thumbs;
      if (!thumbs || !thumbs.swiper) return;
      swiper.thumbs.init();
      swiper.thumbs.update(true);
    },
    slideChange: function slideChange(swiper) {
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    update: function update(swiper) {
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    resize: function resize(swiper) {
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    observerUpdate: function observerUpdate(swiper) {
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    setTransition: function setTransition(swiper, duration) {
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      thumbsSwiper.setTransition(duration);
    },
    beforeDestroy: function beforeDestroy(swiper) {
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;

      if (swiper.thumbs.swiperCreated && thumbsSwiper) {
        thumbsSwiper.destroy();
      }
    }
  }
});

/***/ })

}]);